import React from "react";
import UlLi, { scrollTo, mountCode, initDeepLinkData, deepLinkUrl, urlChangeHandler} from "js/utilities/sdk-doc-utils";
import { Grid, Row, Col, Table, Label, Tabs, Tab, Glyphicon} from "react-bootstrap";
import Highlight from "react-highlight";
import { Navigation, Link } from "react-router";
import UserHandler from "js/utilities/user-handler";
import SDKSidebar from "js/utilities/sdk-sidebar"
import CodeBlocks from "js/utilities/sdk-doc-code-blocks";
import ApptokenDisplay from "js/utilities/get-display-apptoken";
import { ZOOM_ICON } from "js/config.jsx";

export default React.createClass({
  displayName: "release-notes",
  scrollToGuide : null,
  scrollingEl : null,
  getInitialState: function() {
    var data  = [{}];
    var scrollToElement = initDeepLinkData(this.props);

    const query = new URLSearchParams(this.props.location.search);
    const tab = query.get('tab');
    var activeTabKey = "browser";
    var tabs = ["browser", "ios", "android", "server", "rest", "server-docker"]
    if(tabs.indexOf(tab) > -1) {
      activeTabKey = tab;
    }

    return {
      data: data,
      navMenuParent: null,
      navMenu: null,
      scrollToElement: scrollToElement,
      activeTabKey: activeTabKey
    };
  },


  componentDidMount: function() {
    this.scrollingEl = document.getElementById("scrollingEl");
    mountCode(this);
    this.scrollToGuide = this.props.location.query.location;
    scrollingEl.scrollTop = 0;
  },

  componentWillMount() {
    window.addEventListener('popstate', this.urlChanged, false)
  },

  urlChanged() {
    urlChangeHandler();
  },

  render: function() {
    const appToken = "Sign up to get your own Key .";
    if (this.scrollToGuide && this.scrollingEl)
      scrollTo(this.scrollingEl, this.scrollToGuide);
    this.scrollToGuide = null;

    return (
      <div>
        <div className="dash">
          <div className="workspace">
            <div className="workspace__container release-notes">

              <section>
                <div className="title">
                  <Glyphicon glyph="pencil" />
                  <h2>Release Notes</h2>
                </div>
                <p>This page contains a log of new features, bug fixes, known issues, and breaking changes of the latest releases.</p>
                <hr/>
              </section>

              <Tabs defaultActiveKey={this.state.activeTabKey}>
                <Tab eventKey="browser" title="Browser">
                  <br/>
                  <div id="browser-tab">
                  <section id="v8.0">

                  <h3 id="zoom-browser-sdk-v8.12.3">FaceTec Browser SDK v8.12.3</h3>
                  <p className="version-date">July 31, 2020</p>
                  <ul>
                    <li>Misc. bug fixes.</li>
                  </ul>
                  <hr style={{borderTop:"1px solid #C5C5C5"}}/>


                  <h3 id="zoom-browser-sdk-v8.12.2">FaceTec Browser SDK v8.12.2</h3>
                  <p className="version-date">July 28, 2020</p>
                  <ul>
                    <li>Minor capture engine improvements leading to reduced FRRs.</li>
                  </ul>
                  <hr style={{borderTop:"1px solid #C5C5C5"}}/>


                  <h3 id="zoom-browser-sdk-v8.12.1">FaceTec Browser SDK v8.12.1</h3>
                  <p className="version-date">July 16, 2020</p>
                  <ul>
                    <li>Fix issue where cross-domain iFrames would not load the Browser SDK.</li>
                  </ul>
                  <hr style={{borderTop:"1px solid #C5C5C5"}}/>


                  <h3 id="zoom-browser-sdk-v8.12.0">FaceTec Browser SDK v8.12.0</h3>
                  <p className="version-date">Jun 26, 2020</p>
                  <ul>
                    <li>8.12.0 adds new APIs for full customization of the camera initialization, progress, success, and retry animations.  Example animations are now included in the Sample App for the Psuedo-Fullscreen, Well-Rounded, and eKYC Themes.</li>
                    <li>Added API <code>ZoomInitialLoadingAnimationCustomization.customAnimation</code>. This can be used to configure a custom animation to display while the camera is loading. </li>
                    <li>Added API <code>ZoomInitialLoadingAnimationCustomization.animationRelativeScale</code>. This can be used to set the relative sizing of the animation displayed while the camera is loading. </li>
                    <li>Added APIs <code>ZoomResultScreenCustomization.customActivityIndicatorAnimation</code>, <code>ZoomResultScreenCustomization.customResultSuccessAnimation</code> and <code>ZoomResultScreenCustomization.customResultUnsuccessAnimation</code>. These can be used for configuring custom activity indicator and result animations on the Result Screen.</li>
                    <li>Added API <code>ZoomResultScreenCustomization.animationRelativeScale</code>. This can be used to set the relative sizing of the activity indicator and result animations shown on the Result Screen. </li>
                    <li>Misc. bug fixes.</li>
                  </ul>
                  <hr style={{borderTop:"1px solid #C5C5C5"}}/>

                  <h3 id="zoom-browser-sdk-v8.11.0">FaceTec Browser SDK v8.11.1</h3>
                  <p className="version-date">Jun 21, 2020</p>
                  <ul>
                    <li>Fix issue where, if there is a bug in developer code that calls ZoomSession more than once very rapidly, Sessions may not complete.</li>
                    <li>Misc. bug fixes.</li>
                  </ul>
                  <hr style={{borderTop:"1px solid #C5C5C5"}}/>

                  <h3 id="zoom-browser-sdk-v8.11.0">FaceTec Browser SDK v8.11.0</h3>
                  <p className="version-date">Jun 5, 2020</p>
                  <ul>
                    <li>Added API <code>ZoomSessionTimerCustomization.livenessCheckNoInteractionTimeout</code>. This API can be used to specify the amount of time, in seconds, that a user has to complete a Liveness Check Session. The previous API for setting the Liveness Check timeout length, <code>ZoomSessionTimerCustomization.maxTimeOverall</code>, has been deprecated and will be removed in an upcoming version of our SDK.</li>
                    <li>Added API <code>ZoomSessionTimerCustomization.idScanNoInteractionTimeout</code>. This API can be used to specify the amount of time, in seconds, that a user has to complete a Liveness Check Session. </li>
                    <li>Added API <code>ZoomFaceMapResultCallback.uploadMessageOverride()</code> and <code>ZoomIDScanResultCallback.uploadMessageOverride()</code>. These callbacks can be used to dynamically update the message text displayed on the Result Screen during server-side work.</li>
                    <li>Removed <code>ZoomGuidanceCustomization.imageCustomization</code> and <code>ZoomGuidanceImagesCustomization</code> class (deprecated in version 8.5).</li>
                    <li>Misc. bug fixes.</li>
                  </ul>
                  <hr style={{borderTop:"1px solid #C5C5C5"}}/>

                  <h3 id="zoom-browser-sdk-v8.10.2">FaceTec Browser SDK v8.10.2</h3>
                  <p className="version-date">Jun 3, 2020</p>
                  <ul>
                    <li>Misc. bug fixes.</li>
                  </ul>
                  <hr style={{borderTop:"1px solid #C5C5C5"}}/>

                  <h3 id="zoom-browser-sdk-v8.10.1">FaceTec Browser SDK v8.10.1</h3>
                  <p className="version-date">May 29, 2020</p>
                  <ul>
                    <li>Misc. bug fixes.</li>
                  </ul>
                  <hr style={{borderTop:"1px solid #C5C5C5"}}/>

                  <h3 id="zoom-browser-sdk-v8.10.0">FaceTec Browser SDK v8.10.0</h3>
                  <p className="version-date">May 22, 2020</p>
                  <ul>
                    <li><p>Platform Partners that are using the Browser SDK in an iFrame have <Link to="/getting-started?link=browser-iframes">new behavior and some small, required changes</Link> in order to update.  Developers that deploy the Browser SDK into an iFrame must contact us to enable this feature (this is a breaking change if you are using an iFrame with the Browser SDK).</p></li>
                    <li>Added API <code>ZoomSDK.ZoomSessionFromIFrame</code>. This API extends <code>ZoomSDK.ZoomSession</code> and uses the same parameters. This API is required if starting a Zoom session in an IFrame.</li>
                    <li>Added APIs <code>ZoomInitialLoadingAnimationCustomization.backgroundColor</code> and <code>ZoomInitialLoadingAnimationCustomization.foregroundColor</code>. These can be used to configure the color of the background track and foreground fill of the default initial camera loading spinner animation.</li>
                    <li>Added APIs <code>ZoomInitialLoadingAnimationCustomization.messageTextColor</code>, <code>ZoomInitialLoadingAnimationCustomization.messageFont</code>, <code>ZoomInitialLoadingAnimationCustomization.messageTextSize</code>, and <code>ZoomInitialLoadingAnimationCustomization.messageTextSpacing</code>. These can be used to configure the text style of the text displayed below the initial camera loading spinner animation.</li>
                    <li>Added APIs <code>ZoomGuidanceCustomization.readyScreenHeaderAttributedString</code>, <code>ZoomGuidanceCustomization.readyScreenSubtextAttributedString</code>, <code>ZoomGuidanceCustomization.retrySceeenHeaderAttributedString</code>, and <code>ZoomGuidanceCustomization.retryScreenSubtextAttributedString</code>. These allow for configuring an html-attributed string for the various text sections of the Guidance Screens. For instance, these could be used to configure underline styling for part(s) of a text.</li>
                  </ul>
                  <hr style={{borderTop:"1px solid #C5C5C5"}}/>

                  <h3 id="zoom-browser-sdk-v8.9.0">FaceTec Browser SDK v8.9.0</h3>
                  <p className="version-date">May 17, 2020</p>
                  <ul>
                    <li>Added APIs <code>ZoomGuidanceCustomization.readyScreenHeaderFont</code>, <code>ZoomGuidanceCustomization.readyScreenHeaderTextColor</code>, and <code>ZoomGuidanceCustomization.readyScreenHeaderTextSpacing</code>. These allow for configuring the text style of the Ready Screen header message, specifically.</li>
                    <li>Added APIs <code>ZoomGuidanceCustomization.readyScreenSubtextFont</code>, <code>ZoomGuidanceCustomization.readyScreenSubtextTextColor</code>, and <code>ZoomGuidanceCustomization.readyScreenSubtextTextSpacing</code>. These allow for configuring the text style of the Ready Screen subtext message, specifically.</li>
                    <li>Added APIs <code>ZoomGuidanceCustomization.retryScreenHeaderFont</code>, <code>ZoomGuidanceCustomization.retryScreenHeaderTextColor</code>, and <code>ZoomGuidanceCustomization.retryScreenHeaderTextSpacing</code>. These allow for configuring the text style of the Retry Screen header message, specifically.</li>
                    <li>Added APIs <code>ZoomGuidanceCustomization.retryScreenSubtextFont</code>, <code>ZoomGuidanceCustomization.retryScreenSubtextTextColor</code>, and <code>ZoomGuidanceCustomization.retryScreenSubtextTextSpacing</code>. These allow for configuring the text style of the Retry Screen subtext messages, specifically. </li>
                    <li>Misc. bug fixes.</li>
                  </ul>
                  <hr style={{borderTop:"1px solid #C5C5C5"}}/>

                  <h3 id="zoom-browser-sdk-v8.8.0">FaceTec Browser SDK v8.8.0</h3>
                  <p className="version-date">May 8, 2020</p>
                  <ul>
                    <li>New API method <code>ZoomFaceMapResultCallback.succeed(idScanNextStep: ZoomIDScanNextStep)</code> added for use during Photo ID Match flows. Passing in different values of the new enum <code>ZoomIDScanNextStep</code> allows for control over whether you want to skip directly to either the ID Card (with Front and Back) capture process, or the Passport capture process, or to skip the ID Scan process altogether.<br/>
                    You may want to skip directly to a specific type of ID Scan if you know that your Users are only using one particular type of ID, or you may want to skip the entire ID Scan process if you have custom server-side logic that would deem certain scenarios as not-needing of an ID Scan.
                    </li>
                    <li>Misc. bug fixes.</li>
                  </ul>
                  <hr style={{borderTop:"1px solid #C5C5C5"}}/>

                  <h3 id="zoom-browser-sdk-v8.7.0">FaceTec Browser SDK v8.7.0</h3>
                  <p className="version-date">April 24, 2020</p>
                  <ul>
                    <li>New API <code>ZoomGuidanceCustomization.cameraPermissionsScreenLaunchAction</code>. This is used to configure the behavior of the action button on the Camera Permissions Screen. <code>ZoomGuidanceCustomization.cameraPermissionsScreenLaunchAction</code> can be set using the new enum <code>ZoomCameraPermissionsLaunchAction</code>. Use <code>ZoomCameraPermissionsLaunchAction.Cancel</code> to cancel from the session when the action button is pressed. Use <code>ZoomCameraPermissionsLaunchAction.LaunchURL</code> to maintain legacy behavior, where the URL supplied in the localized string reference <code>ZoomStrings.zoom_browser_camera_help_action_link</code> will be launched in a new browser tab when the action button is pressed. <code>ZoomCameraPermissionsLaunchAction.Cancel</code> is the default value of this new API.</li>
                    <li>Misc. bug fixes.</li>
                  </ul>
                  <hr style={{borderTop:"1px solid #C5C5C5"}}/>

                  <h3 id="zoom-browser-sdk-v8.6.0">FaceTec Browser SDK v8.6.0</h3>
                  <p className="version-date">April 3, 2020</p>
                  <ul>
                    <li>Add overloaded method to ZoomIDScanResultCallback, <code>ZoomIDScanResultCallback.retry(ZoomIDScanRetryMode, String)</code>, where the second parameter specifies the string to display on the Result Screen for an unsuccessful ID Scan attempt.</li>
                    <li>Misc. bug fixes.</li>
                  </ul>
                  <hr style={{borderTop:"1px solid #C5C5C5"}}/>

                  <h3 id="zoom-browser-sdk-v8.5.0">FaceTec Browser SDK v8.5.0</h3>
                  <p className="version-date">March 28, 2020</p>
                  <ul>
                    <li>Removed ID Scan Capture Frame Images. The ID Scan Capture Frame is now configured using the newly added customization APIs in <code>ZoomIDScanCustomization</code>.</li>
                    <li>New APIs <code>ZoomIDScanCustomization.captureScreenBackgroundColor</code>, <code>ZoomIDScanCustomization.captureFrameStrokeColor</code>, <code>ZoomIDScanCustomization.captureFrameStrokeWidth</code>, and <code>ZoomIDScanCustomization.captureFrameCornerRadius</code>. These are used to configure the look of the ID Scan Capture Frame.</li>
                    <li>New APIs <code>ZoomGuidanceCustomization.retryScreenIdealZoomImage</code> and <code>ZoomGuidanceCustomization.cameraPermissionsScreenImage</code>. These have been added to replace the deprecated APIs in <code>ZoomGuidanceImagesCustomization</code> for configuring the Retry Screen’s Ideal Image and Camera Permissions Screen Image.</li>
                    <li>Deprecated <code>ZoomGuidanceImagesCustomization</code>, <code>ZoomGuidanceCustomization.imageCustomization</code>, <code>ZoomGuidanceImagesCustomization.idealZoomImage</code>, and <code>ZoomGuidanceImagesCustomization.cameraPermissionsScreenImage</code>. The Retry Screen’s Ideal Image and Camera Permissions Screen Image are now configured using the new APIs added to <code>ZoomGuidanceCustomization</code>.</li>
                    <li>Update Sample App look and feel.</li>
                    <li>Misc. bug fixes.</li>
                  </ul>
                  <hr style={{borderTop:"1px solid #C5C5C5"}}/>

                  <h3 id="zoom-browser-sdk-v8.4.0">FaceTec Browser SDK v8.4.0</h3>
                  <p className="version-date">March 13, 2020</p>
                  <ul>
                    <li>New Feature: <Link to="/session-tokens">Session Tokens</Link>.</li>
                    <li>Updated the Sample App to use Session Tokens. </li>
                    <li>Removed matching-search-age from sample apps.</li>
                    <li>New API <code>ZoomFeedbackCustomization.relativeWidth</code> for specifying the desired width of the FaceTec SDK Feedback Bar.</li>
                    <li>New APIs <code>ZoomGuidanceCustomization.buttonRelativeWidth</code> and <code>ZoomIDScanCustomization.buttonRelativeWidth</code> for specifying the desired width of the action buttons during Guidance Screens and Identity Check Screens.</li>
                    <li>New API <code>ZoomGuidanceCustomization.enableRetryScreenBulletedInstructions</code> to control whether the Retry Screen instruction messages are separated out and preceded with bullet-points, or instead, combined to form a multi-line sentence(s).</li>
                    <li>New API <code>ZoomCancelButtonCustomization.setCustomLocation</code> for specifying custom frame location and size for the cancel button. <code>ZoomCancelButtonCustomization.location</code> must be set to a new enum value: <code>ZoomCancelButtonLocation.Custom</code> in order to use the customLocation API.</li>
                    <li>New API <code>ZoomFrameCustomization.shadow</code> for determining the shadow displayed behind the FaceTec SDK Frame. <code>ZoomFrameCustomization.shadow</code> can be configured to values of, and will behave like, the box-shadow CSS attribute.</li>
                    <li>New APIs <code>ZoomGuidanceCustomization.retryScreenSlideshowImages</code>, <code>ZoomGuidanceCustomization.retryScreenSlideshowInterval</code>, and <code>ZoomGuidanceCustomization.enableRetryScreenSlideshowShuffle</code>. These are used to set an array of ‘ideal’ example images to cycle through on the Retry Screen. Allows for control over the interval between image transitions, and whether to randomly shuffle the order of the image array before each time the retry screen is shown.</li>
                    <li>New APIs <code>ZoomGuidanceCustomization.retryScreenImageBorderColor</code>, <code>ZoomGuidanceCustomization.retryScreenImageBorderWidth</code>, and <code>ZoomGuidanceCustomization.retryScreenImageCornerRadius</code>. These are used to control the image border color, width, and corner radius of the images shown on the Retry Screen. For upgrading developers, please note, the new default values for these customizations are custom and thus differ from the Retry Screen image border styles in previous versions.</li>
                    <li>New API <code>ZoomGuidanceCustomization.retryScreenOvalStrokeColor</code> for controlling the color of the oval stroke that overlays the ‘ideal’ example image on the Retry Screen.</li>
                    <li>New APIs <code>ZoomGuidanceCustomization.buttonTextDisabledColor</code>, <code>ZoomGuidanceCustomization.buttonBackgroundDisabledColor</code>, <code>ZoomIDScanCustomization.buttonTextDisabledColor</code>, and <code>ZoomIDScanCustomization.buttonBackgroundDisabledColor</code>. These are used to control the button text and background color of the action buttons. For upgrading developers, please note, the new default values for these customizations are custom and thus differ from the disabled button styles in previous versions.</li>
                    <li>New APIs <code>ZoomResultScreenCustomization.messageTextSpacing</code>, <code>ZoomGuidanceCustomization.headerTextSpacing</code>, <code>ZoomGuidanceCustomization.subtextTextSpacing</code>, <code>ZoomGuidanceCustomization.buttonTextSpacing</code>, <code>ZoomIDScanCustomization.headerTextSpacing</code>, <code>ZoomIDScanCustomization.subtextTextSpacing</code>, and <code>ZoomIDScanCustomization.buttonTextSpacing</code>. These are used to control the spacing between the characters of the text.</li>
                    <li>New API <code>ZoomOverlayCustomization.showBrandingImage</code> to control whether to show a branding image on the overlay background.</li>
                    <li>ID Scan Capture Screen Frame images have been deprecated and will be removed in an upcoming version of the FaceTec SDK. Future versions will configure the ID Scan Capture Frame's background and stroke colors programmatically.</li>
                    <li>The ability to programmatically cancel from the User Session has been removed.</li>
                    <li>Miscellaneous improvements to performance, security, reliability, and UX.</li>
                  </ul>
                  <hr style={{borderTop:"1px solid #C5C5C5"}}/>

                  <h3 id="zoom-browser-sdk-v8.3.3">FaceTec Browser SDK v8.3.3</h3>
                  <p className="version-date">March 6, 2020</p>
                  <ul>
                    <li><p>See 8.4.0 Notes.</p></li>
                  </ul>
                  <hr style={{borderTop:"1px solid #C5C5C5"}}/>

                  <h3 id="zoom-browser-sdk-v8.3.2">FaceTec Browser SDK v8.3.2</h3>
                  <p className="version-date">February 19, 2020</p>
                  <ul>
                    <li>Improved handling of camera permissions.</li>
                  </ul>
                  <hr style={{borderTop:"1px solid #C5C5C5"}}/>

                  <h3 id="zoom-browser-sdk-v8.3.1">FaceTec Browser SDK v8.3.1</h3>
                  <p className="version-date">February 18, 2020</p>
                  <ul>
                    <li>Enhanced logic for populating low quality audit trail collection.</li>
                  </ul>
                  <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                  <h3 id="zoom-browser-sdk-v8.3.0">FaceTec Browser SDK v8.3.0</h3>
                  <p className="version-date">February 14, 2020</p>
                  <ul>
                    <li>New <code>customActivityIndicatorImage</code> and <code>customActivityIndicatorRotationInterval</code> APIs. These APIs allow customization of the activity indicator animation.</li>
                    <li>New <code>showUploadProgressBar</code> API. This API controls the disablement of the progress bar.</li>
                    <li><p>See <Link to="/ui-customization">FaceTec UI Customization Reference</Link> for the latest available customizations.</p></li>
                    <li>Misc. bug fixes.</li>
                  </ul>
                  <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                  <h3 id="zoom-browser-sdk-v8.2.0">FaceTec Browser SDK v8.2.0</h3>
                  <p className="version-date">January 24, 2020</p>
                  <ul>
                    <li><strong>Unmanaged Sessions</strong> and associated feature flags have been removed and are no longer supported.  This includes undocumented feature flags that previously allowed control over FaceTec Frame size, top margin, setting semi-transparent backgrounds and oval strokes, low light mode disablement, and removal of the Get Ready and Retry Screens.  Unmanaged Sessions are removed in Browser and deprecated in future versions of iOS/Android to ensure the highest user conversion rates possible and ensure the highest level of security by default.</li>
                    <li>Internal updates to support the upcoming release of <strong>FaceTec Server Dashboard</strong>, a web interface that will ship in an upcoming version of FaceTec Server that gives FaceTec Customers and Partners the ability to review and inspect all end user interactions with the FaceTec SDK platform, including Audit Trail Images, Liveness Checks, Enrollments, Authentications, Photo ID Matches, and enables the ability to search for Duplicate Accounts and Manage a Fraudulent User List.</li>
                    <li>New <code>ZoomFaceMapMetrics.lowQualityAuditTrailCompressedBase64</code> API.  This API returns an array of Audit Trail Images that illustrate the likely cause of Liveness or Matching retry. The 0th image of this array is also used on the Retry Screen.</li>
                    <li>New <code>setLowLightCustomization</code> API.  This API takes the same ZoomCustomization object that <code>setCustomization</code> does, but controls what FaceTec looks like in low light mode.</li>
                    <li>Low light environments are now detected on the "Get Ready" Screen, speeding up User Sessions, and increasing usability and user success rates.</li>
                    <li>Fixes for compatibility and better camera size and aspect selection across devices.</li>
                    <li>Fixes for better screen transitions and general look and feel improvements across devices.</li>
                    <li>Improved compatibility and UX for Photo ID Match screens.</li>
                    <li>Numerous of other internal stability, performance, and security improvements.</li>
                  </ul>
                  <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                  <h3 id="zoom-browser-sdk-v8.1.1">FaceTec Browser SDK v8.1.1</h3>
                  <p className="version-date">December 20, 2019</p>
                  <ul>
                    <li>Fix issue where Photo ID Scan would freeze on certain devices.</li>
                  </ul>

                    <h3 id="zoom-browser-sdk-v8.1.0">FaceTec Browser SDK v8.1.0</h3>
                    <p className="version-date">December 18, 2019</p>
                    <ul>
                      <li>The FaceTec 8.1.0 release contains improvements to security, usability, user experience, and developer experience.  FaceTec SDKs v8.1.0 is non-breaking and can be installed by a simple binary replacement.</li>
                      <li>FaceTec Developer Docs Site refresh!</li>
                      <li>Default user experience refresh.</li>
                      <li>Algorithm accuracy improvements.</li>
                      <li>There is now just one main Sample App to demonstrate core functionality.</li>
                      <li>Added a Design Showcase button that toggles between several compelling "themes" that demonstrate how the FaceTec SDK Customization class can be used to significantly alter the look and feel of FaceTec SDKs.</li>
                      <li>ZoomManagedSession has been refactored into much small components called Processors.  This code remains as open source and can be found in the Sample App.</li>
                      <li>The Lockout Screen has been removed.</li>
                      <li>All guidance screens containing "pictograms" have been removed.  This includes the Angle Guidance, Lighting Guidance, and Webcam Guidance (Browser-only) Screens.  The Get Ready Screen (for new sessions) and the Retry Guidance Screens are now the only two required screens.</li>
                      <li>Fixed issues where certain customizations were not getting applied and where certain customization combinations resulted in undesirable visual effects.</li>
                      <li>Numerous device/camera compatibility fixes.</li>
                      <li>Numerous additional FaceMap security and integrity checks are performed throughout the FaceTec SDK process.</li>
                      <li>Fallback images have been embedded into the SDK to improve integration experience.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                    <h3 id="zoom-browser-sdk-v8.0.16">FaceTec Browser SDK v8.0.16</h3>
                    <p className="version-date">December 10, 2019</p>
                    <ul>
                    <li>Misc. bug fixes.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-browser-sdkv8.0.13-15">FaceTec Browser SDK v8.0.13-15</h3>
                    <p className="version-date">December 4, 2019</p>
                    <ul>
                      <li>Added ZoomGlobalState.js file so it would be a single point to modify your keys.</li>
                      <li>Updated Docker script so you may specify public FaceMap encryption key and SFTP Key through build arguments.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-browser-sdk-v8.0.12">FaceTec Browser SDK v8.0.12</h3>
                    <p className="version-date">December 2, 2019</p>
                    <ul>
                      <li>Misc. bug fixes.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-browser-sdk-v8.0.11">FaceTec Browser SDK v8.0.11</h3>
                    <p className="version-date">November 27, 2019</p>
                    <ul>
                      <li>Misc. bug fixes.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-browser-sdk-v8.0.10">FaceTec Browser SDK v8.0.10</h3>
                    <p className="version-date">November 20, 2019</p>
                    <ul>
                      <li>Initial release of Docker build script.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-browser-sdk-v8.0.9">FaceTec Browser SDK v8.0.9</h3>
                    <p className="version-date">November 13, 2019</p>
                    <ul>
                      <li>Misc. bug fixes.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-browser-sdk-v8.0.8">FaceTec Browser SDK v8.0.8</h3>
                    <p className="version-date">November 7, 2019</p>
                    <ul>
                      <li>Minor bug fixes.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                    <h3 id="zoom-browser-sdk-v8.0.7">FaceTec Browser SDK v8.0.7</h3>
                      <p className="version-date">November 6, 2019</p>
                      <ul>
                        <li>Add Typescript Managed Session Example.</li>
                        <li>Update Typescript declaration files.</li>
                        <li>Misc. UI fixes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>



                      <h3 id="zoom-browser-sdk-v8.0.6">FaceTec Browser SDK v8.0.6</h3>
                      <p className="version-date">October 16, 2019</p>
                      <ul>
                        <li>Misc. UI fixes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-browser-sdk-v8.0.5">FaceTec Browser SDK v8.0.5</h3>
                      <p className="version-date">October 11, 2019</p>
                      <ul>
                        <li>Updates to in app documentation.</li>
                        <li>Reorganize sample apps, consolidate sample app images and locations for clarity.</li>
                        <li>Updated sample apps to demonstrate custom image and custom resource locations.</li>
                        <li>Enhanced performance especially on lower/mid-tier mobile devices.</li>
                        <li>Updated Oval progress spinner to behave more like the FaceTec iOS and Android SDK&rsquo;s.</li>
                        <li>Numerous bug fixes and UI/UX updates.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-browser-sdk-v8.0.4">FaceTec Browser SDK v8.0.4</h3>
                      <p className="version-date">October 8, 2019</p>
                      <ul>
                        <li>Add <code>ZoomSDK.setFaceMapEncryptionKey()</code> API for parity with iOS/Android, allowing developers to specify the public key used as one of the inputs to FaceMap encryption.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-browser-sdk-v8.0.3">FaceTec Browser SDK v8.0.3</h3>
                      <p className="version-date">October 4, 2019</p>
                      <ul>
                        <li>Fixed issues around scenarios where if interface components were disabled, the image resources would still be required.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-browser-sdk-v8.0.2">FaceTec Browser SDK v8.0.2</h3>
                      <p className="version-date">September 27, 2019</p>
                      <ul>
                        <li>Known issue - There are multiple copies of the folder "zoom-guidance-images" — This folder contains extra guidance image sets that can be used by the developer.  The Complete App also demonstrates how these can be shuffled for everything User Session.  In a future release, these will be moved to a new location and renamed to avoid confusion with the core/default/required set of images.</li>
                        <li>Updates to Sample Apps for consistency and clarity.</li>
                        <li>Minor bug fixes, stability improvements, and performance.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-browser-sdk-v8.0.1">FaceTec Browser SDK v8.0.1</h3>
                      <p className="version-date">September 20, 2019</p>
                      <ul>
                        <li><p>Update <code>SampleLocalizationStrings.js</code> to include all correct customizable strings.</p></li>
                        <li><p>UI, performance, and reliability enhancements. Certain lower tier devices are now much faster.</p></li>
                        <li><p>Improved progress spinner look and feel.</p></li>
                        <li><p>Fixed low light mode rendering quirks on certain devices.</p></li>
                        <li><p>Fixed an issue where Time Based Session Images would not return.</p></li>
                        <li><p>Changed default required Image filenames and default directory.  v8.0.0 style will continue to function but the new single "zoom_images" directory with a flat list of files is preferred.  To update your v7.x.x app or v8.0.0 app, simply copy the zoom_images directory from the Basic Sample into your project.  You may also use the <code>ZoomSDK.setImagesDirectory</code> API (new, see below) to set a custom location for the required Images.</p></li>
                        <li><p>Added <code>ZoomSDK.setImagesDirectory</code> API to specify a custom location to load images from. Please see the sample-custom-images-location for a working example.</p></li>
                        <li><p>Updated sample app code for clarity and consistency.</p></li>
                        <li><p>Updated ZoomManagedSessionSource files for clarity and consistency.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h2 id="zoom-browser-8.0.0-has-been-released">FaceTec SDKs v8.0.0 has been released!</h2>
                      <p className="version-date">September 13, 2019</p>
                      <ul>
                        <li><p>Please see the <Link to="/docs">docs home</Link> for updated guides including Quick Start, Advanced, and Customizations.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>
                    </section>

                    <section id="v7.0">
                      <h3 id="zoom-browser-sdk-v7.1.18">FaceTec Browser SDK v7.1.18</h3>
                      <p className="version-date">July 30, 2019</p>
                      <ul>
                        <li><p>Minor bug fixes.</p></li>
                        <li><p>1:N Search, 2D Image Enrollment, and Paste Image feature additions to the 2D/3D Matching Sample.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-browser-sdk-v7.1.17">FaceTec Browser SDK v7.1.17</h3>
                      <p className="version-date">July 16, 2019</p>
                      <ul>
                        <li><p>Minor bug fixes.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-browser-sdk-v7.1.16">FaceTec Browser SDK v7.1.16</h3>
                      <p className="version-date">June 16, 2019</p>
                      <ul>
                        <li><p>Minor bug fixes.  Update 2D/3D Matching Sample for new FaceTec Match Levels.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-browser-sdk-v7.1.15">FaceTec Browser SDK v7.1.15</h3>
                      <p className="version-date">May 29, 2019</p>
                      <ul>
                        <li><p>Fix bug that was blocking initialize when localStorage is unavailable.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-browser-sdk-v7.1.14">FaceTec Browser SDK v7.1.14</h3>
                      <p className="version-date">May 17, 2019</p>
                      <ul>
                        <li><p>Return 6 audit trail images rather than 5.</p></li>
                        <li><p>Minor bug fixes.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-browser-sdk-v7.1.13">FaceTec Browser SDK v7.1.13</h3>
                      <p className="version-date">April 25, 2019</p>
                      <ul>
                        <li><p>Algorithm improvements with enhanced face feedback.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-browser-sdk-v7.1.12">FaceTec Browser SDK v7.1.12</h3>
                      <p className="version-date">April 17, 2019</p>
                      <ul>
                        <li><p>Minor bug fix to bring offline Server Usage Logs for the Browser SDK in line with iOS/Android.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-browser-sdk-v7.1.11">FaceTec Browser SDK v7.1.11</h3>
                      <p className="version-date">April 1, 2019</p>
                      <ul>
                        <li><p>Update to build process to make module smaller.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-browser-sdk-v7.1.10">FaceTec Browser SDK v7.1.10</h3>
                      <p className="version-date">March 27, 2019</p>
                      <ul>
                        <li><p>Fix bug where console logs were showing in some code paths.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-browser-sdk-v7.1.9">FaceTec Browser SDK v7.1.9</h3>
                      <p className="version-date">March 22, 2019</p>
                      <ul>
                        <li><p>Fix bug where some debug data was not being logged correctly.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-browser-sdk-v7.1.8">FaceTec Browser SDK v7.1.8</h3>
                      <p className="version-date">March 21, 2019</p>
                      <ul>
                        <li><p>Misc. bug fixes.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-browser-sdk-v7.1.7">FaceTec Browser SDK v7.1.7</h3>
                      <p className="version-date">March 17, 2019</p>
                      <ul>
                        <li><p>Misc. bug fixes.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-browser-sdk-v7.1.6">FaceTec Browser SDK 7.1.6</h3>
                      <p className="version-date">March 11, 2019</p>
                      <ul>
                        <li><p>Fix issue where ZoomCancelButtonCustomization was not able to be used.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-browser-sdk-v7.1.5">FaceTec Browser SDK v7.1.5</h3>
                      <p className="version-date">March 10, 2019</p>
                      <ul>
                        <li><p>COMPATIBILITY NOTICE: FaceTec Server 7.1.1 is required for FaceTec Browser SDK 7.1.5 and above.</p></li>
                        <li><p>Initial implementation of FaceTec SDKs Generation 2 (G2) UX -- User Session Capture is now much easier.  Requires FaceTec Server 7.1.1.</p></li>
                        <li><p>High-priority updates to sample camera code that handles more camera types and selects the correct high resolution camera for many more devices.</p></li>
                        <li><p>Updates to sample applications.  Complete app now contains much more hardened code around initialization and error handling, as well as mobile look and feel.</p></li>
                        <li><p>Updates to New User Guidance and Retry Screens.</p></li>
                        <li><p>Add new customization class ZoomSessionTimerCustomization.  Using this class, you can configure maxTimeToDetectFirstFace, maxTimeToDetectFirstFaceInPhaseTwo, and maxTimeOverall.  These properties control the amount of time in seconds before FaceTec SDKs will timeout in various cases.  maxTimeToDetectFirstFace controls the amount of time before the User Session will timeout if FaceTec SDKs do not find a good at the far out, unzoomed distance -- the default is 7 seconds.  maxTimeToDetectFirstFaceInPhaseTwo controls the amount of time before the User Session will timeout if FaceTec SDKs do not find a good face at the close, close distance (this timeout is measured from the time the user puts his/her face in the far out, unzoomed oval) -- the default is 7 seconds.  maxTimeOverall controls the amount of time before the User Session will timeout overall - the default is 30 seconds.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-browser-sdk-v7.1.4">FaceTec Browser SDK 7.1.4</h3>
                      <p className="version-date">March 7, 2019</p>
                      <ul>
                        <li><p>Corrected TS type for zoomSession.capture.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-browser-sdk-v7.1.3">FaceTec Browser SDK 7.1.3</h3>
                      <p className="version-date">March 4, 2019</p>
                      <ul>
                        <li><p>Added comments to TS declaration files for all enums returned by the major Browser SDK API calls.</p></li>
                        <li><p>Created 4 TS declaration files.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-browser-sdk-v7.1.2">FaceTec Browser SDK 7.1.2</h3>
                      <p className="version-date">February 17, 2019</p>
                      <ul>
                        <li><p>initialize() is now significantly faster.</p></li>
                        <li><p>Creating the facemap at the end of the User Session is now significantly faster.</p></li>
                        <li><p>Fix issue in layout when using ZoomCancelButtonLocation.TopRight.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-browser-sdk-v7.1.1">FaceTec Browser SDK 7.1.1</h3>
                      <p className="version-date">February 15, 2019</p>
                      <h4>Updates & Bug Fixes</h4>
                      <ul>
                        <ul>
                        <li><p>Added new "Complete Sample" showing sample implementations of Enrollment and Authentication.</p></li>
                        <li><p>onZoomSessionComplete now returns a "facemap" property on the ZoomSessionResult object.  This property points to the same data as the "sessionData" property.  All Sample Apps have been updated to use this new "facemap" property.  This property can be sent to the FaceTec SDK REST API in the "facemap" parameter.  The sessionData property will be deprecated in a future release of the FaceTec Browser SDK.</p></li>
                        <li><p>Misc. UI, performance, and stability bug fixes.</p></li>
                        </ul>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-browser-sdk-v7.1">FaceTec Browser SDK v7.1</h3>
                      <p className="version-date">January 31, 2019</p>
                      <h4>Bug Fixes</h4>
                      <ul>
                        <ul>
                          <li><p>Complete all FaceTec processing and DOM maniputlation before calling onZoomSessionComplete.</p></li>
                          <li><p>Various UI tweaks and minor fixes.</p></li>
                        </ul>
                      </ul>
                      <h4>Major Updates</h4>
                      <ul>
                        <h4 style={{fontSize: "1.2em"}}>API Changes</h4>
                        <ul>
                          <li><p>Stabilize APIs and make the result objects as consistent with mobile platforms as possible.</p></li>
                          <li><p><code>ZoomSDK.preload</code> now takes care of just the preloading of resources.</p></li>
                          <li><p>Added a new API <code>ZoomSDK.prepareInterface</code> that takes care of the initialization of our internal interface.</p></li>
                          <li><p>Added <code>ZoomSession.cancel</code> to allow developers to programatically cancel the current User Session. See the new API tester sample for more details.</p></li>
                          <li><p>Added an optional callback the developer can specify via <code>ZoomSession.setOnZoomSessionProcessingStarted</code> that is called the instant that the User Session is complete and FaceTec starts doing post-processing to create the User Session payload.  This callback, if defined, will be called before onZoomSessionComplete.</p></li>
                          <li><p>Added official support for <code>ZoomSDK.initializeWithLicenseText</code> which allows offline Key verification without a network connection. See the initialization section of <span><Link to="/web-guide">FaceTec Device SDK - Browser Guide</Link></span> for more details.</p></li>
                          <li><p>New customizations added for frame, oval, colors, font, and animations.</p></li>
                          <li><p><code>onZoomSessionComplete</code> is now guaranteed to be called after all FaceTec processing, DOM manipulation, and code execution has occurred. </p></li>
                        </ul>
                        <h4 style={{fontSize: "1.2em"}}>Updates</h4>
                        <ul>
                          <li><p>Huge performance improvements in all core components of the platform.</p></li>
                          <li><p>Support for Landscape Mode on Android.  Portrait is still the recommended mode and is required on iOS, where we know the camera is always on top when in Portrait. Camera on top in Portrait mode will <strong>always</strong> be the best user experience.</p></li>
                          <li><p>Revised minimal sample app makes clear the bare minimum html and JS code required to make FaceTec working.</p></li>
                          <li><p>Our Minimal and Liveness Samples are significantly minified -- we&rsquo;ve eliminated thousands of lines of code that we had in shared helper functions in order to really make clear what is going on.  We have inlined most of the code so that developers can take a look at the Sample Apps and not need to go anywhere else but the core functions in order to understand everything that is going on. The Samples are also mobile friendly, so you can see examples of how to write a concise implementation that accounts for both desktop and mobile web modalities.</p></li>
                          <li><p>New API Tester Sample allows the developer to call vitrually all of the Browser SDK api&rsquo;s in any order and state to learn about the SDK&rsquo;s behaviour. For example, we added a special "capture and immediately unload" function to the API Tester to demonstrate the ability to immediately uninitialize FaceTec after receiving onZoomSessionComplete</p></li>
                        </ul>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-browser-sdk-v7.0.0">v7.0.0</h3>
                      <p className="version-date">December 14, 2018</p>
                      <h4>Platform-wide update to FaceTec&rsquo;s industry-leading face authentication technology.<br /><br />Major Updates:<br /><br /></h4>
                      <ul>
                        <ul>
                          <li><p>Capture speed and frame processing rate greatly increased.</p></li>
                          <li><p>Fixed over 100 device/browser/version compatibility issues.</p></li>
                          <li><p>Significant updates to interface look, feel, smoothness, and transitions.</p></li>
                          <li><p>Updates to camera handling, initialization, loading resources both in the core module and in the recommend samples.</p></li>
                          <li><p>New sample app added called the "Onboarding Sample" which is a use case demo of building an enrollment, authentication, and/or onboarding flow to your website.</p></li>
                          <li><p>Managed Rest API - Ability to save & return thumbnail image attached to facemap</p></li>
                        </ul>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>
                    </section>
                  </div>
                </Tab>
                <Tab eventKey="ios" title="iOS">
                  <br/>
                  <div id="ios-tab">
                    <section id="v8.0">

                    <h3 id="zoom-ios-sdk-v8.12.0">FaceTec iOS SDK v8.12.0</h3>
                      <p className="version-date">June 26, 2020</p>
                      <ul>
                        <li>8.12.0 adds new APIs for full customization of the progress, success, and retry animations.  Example animations are now included in the Sample App for the Psuedo-Fullscreen, Well-Rounded, and eKYC Themes.</li>
                        <li>Added API delegate <code>ZoomCustomAnimationDelegate</code> and methods: <code>onCreateNewCustomActivityIndicatorAnimationView</code>, <code>onCreateNewResultScreenSuccessAnimationView</code>, and <code>onCreateNewResultScreenUnsuccessAnimationView</code>. This delegate can be used for configuring custom activity indicator and result animations on the Result Screen.</li>
                        <li>Added API <code>ZoomResultScreenCustomization.animationRelativeScale</code>. This can be used to set the relative sizing of the activity indicator and result animations shown on the Result Screen. </li>
                        <li>Misc. bug fixes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-ios-sdk-v8.11.0">FaceTec iOS SDK v8.11.0</h3>
                      <p className="version-date">June 5, 2020</p>
                      <ul>
                        <li>Added API <code>ZoomCustomization.sessionTimerCustomization</code>and its class <code>ZoomSessionTimerCustomization</code>. This API and class object can be used to configure the timeout lengths for the Liveness Check and ID Scan processes. </li>
                        <li>Added API <code>ZoomSessionTimerCustomization.livenessCheckNoInteractionTimeout</code>. This API can be used to specify the amount of time, in seconds, that a user has to complete a Liveness Check Session. The previous API for setting the Liveness Check timeout length, <code>ZoomSDK.activeTimeoutInSeconds</code>, has been deprecated and will be removed in an upcoming version of our SDK.</li>
                        <li>Added API <code>ZoomSessionTimerCustomization.idScanNoInteractionTimeout</code>. This API can be used to specify the amount of time, in seconds, that a user has to complete a Liveness Check Session. </li>
                        <li>Added API <code>ZoomFaceMapResultCallback.uploadMessageOverride()</code> and <code>ZoomIDScanResultCallback.uploadMessageOverride()</code>. These callbacks can be used to dynamically update the message text displayed on the Result Screen during server-side work.</li>
                        <li>Removed <code>ZoomGuidanceCustomization.imageCustomization</code> and <code>ZoomGuidanceImagesCustomization</code> class (deprecated in version 8.5).</li>
                        <li>Removed <code>ZoomFaceBiometricMetrics.timeBasedSessionImages</code> API (deprecated in version 8.4.1).</li>
                        <li>Misc. bug fixes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-ios-sdk-v8.10.0">FaceTec iOS SDK v8.10.0</h3>
                      <p className="version-date">May 22, 2020</p>
                      <ul>
                        <li>Misc. bug fixes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-ios-sdk-v8.9.0">FaceTec iOS SDK v8.9.0</h3>
                      <p className="version-date">May 17, 2020</p>
                      <ul>
                        <li>Added APIs <code>ZoomGuidanceCustomization.readyScreenHeaderFont</code>, <code>ZoomGuidanceCustomization.readyScreenHeaderTextColor</code>, and <code>ZoomGuidanceCustomization.readyScreenHeaderTextSpacing</code>. These allow for configuring the text style of the Ready Screen header message, specifically. </li>
                        <li>Added APIs <code>ZoomGuidanceCustomization.readyScreenSubtextFont</code>, <code>ZoomGuidanceCustomization.readyScreenSubtextTextColor</code>, and <code>ZoomGuidanceCustomization.readyScreenSubtextTextSpacing</code>. These allow for configuring the text style of the Ready Screen subtext message, specifically.  </li>
                        <li>Added APIs <code>ZoomGuidanceCustomization.retryScreenHeaderFont</code>, <code>ZoomGuidanceCustomization.retryScreenHeaderTextColor</code>, and <code>ZoomGuidanceCustomization.retryScreenHeaderTextSpacing</code>. These allow for configuring the text style of the Retry Screen header message, specifically. </li>
                        <li>Added APIs <code>ZoomGuidanceCustomization.retryScreenSubtextFont</code>, <code>ZoomGuidanceCustomization.retryScreenSubtextTextColor</code>, and <code>ZoomGuidanceCustomization.retryScreenSubtextTextSpacing</code>. These allow for configuring the text style of the Retry Screen subtext messages, specifically. </li>
                        <li>Added APIs <code>ZoomGuidanceCustomization.readyScreenHeaderAttributedString</code>, <code>ZoomGuidanceCustomization.readyScreenSubtextAttributedString</code>, <code>ZoomGuidanceCustomization.retrySceeenHeaderAttributedString</code>, and <code>ZoomGuidanceCustomization.retryScreenSubtextAttributedString</code>. These allow for configuring an attributed string for the various text sections of the Guidance Screens. For instance, these could be used to configure underline styling for part(s) of a text.</li>
                        <li>Misc. bug fixes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-ios-sdk-v8.8.0">FaceTec iOS SDK v8.8.0</h3>
                      <p className="version-date">May 8, 2020</p>
                      <ul>
                        <li>New API method <code>ZoomFaceMapResultCallback.onFaceMapResultSucceed(idScanNextStep: ZoomIDScanNextStep)</code> added for use during Photo ID Match flows. Passing in different values of the new enum <code>ZoomIDScanNextStep</code> allows for control over whether you want to skip directly to either the ID Card (with Front and Back) capture process, or the Passport capture process, or to skip the ID Scan process altogether.<br/>
                        You may want to skip directly to a specific type of ID Scan if you know that your Users are only using one particular type of ID, or you may want to skip the entire ID Scan process if you have custom server-side logic that would deem certain scenarios as not-needing of an ID Scan.
                        </li>
                        <li>Misc. bug fixes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-ios-sdk-v8.7.1">FaceTec iOS SDK v8.7.1</h3>
                      <p className="version-date">April 27, 2020</p>
                      <ul>
                        <li>Misc. bug fixes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-ios-sdk-v8.7.0">FaceTec iOS SDK v8.7.0</h3>
                      <p className="version-date">April 24, 2020</p>
                      <ul>
                        <li>New APIs <code>ZoomIDScanCustomization.captureScreenFocusMessageFont</code>, <code>ZoomIDScanCustomization.captureScreenFocusMessageTextColor</code>, and <code>ZoomIDScanCustomization.captureScreenFocusMessageTextSpacing</code>. These are used to configure the style of the newly added tap-to-focus message that is displayed below the Capture Frame on the Identity Document Capture Screen.</li>
                        <li>New localized string, <code>ZoomStrings.zoom_idscan_capture_tap_to_focus_message</code>. This is used to set the text of the newly added tap-to-focus message that is displayed below the Capture Frame on the Identity Document Capture Screen.</li>
                        <li>Removed API <code>ZoomIDScanCustomization.reviewScreenDocumentPreviewCornerRadius</code>. The corner radius configured for the Identity Document Capture Frame using <code>ZoomIDScanCustomization.captureFrameCornerRadius</code> will be used for the captured document preview on the Identity Document Review Screen.</li>
                        <li>Misc. bug fixes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-ios-sdk-v8.6.0">FaceTec iOS SDK v8.6.0</h3>
                      <p className="version-date">April 3, 2020</p>
                      <ul>
                        <li>Add overloaded method to ZoomIDScanResultCallback, <code>ZoomIDScanResultCallback.onIDScanResultRetry(ZoomIDScanRetryMode, String)</code>, where the second parameter specifies the string to display on the Result Screen for an unsuccessful ID Scan attempt.</li>
                        <li>Misc. bug fixes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-ios-sdk-v8.5.0">FaceTec iOS SDK v8.5.0</h3>
                      <p className="version-date">March 28, 2020</p>
                      <ul>
                        <li>Removed ID Scan Capture Frame Images. The ID Scan Capture Frame is now configured using the newly added customization APIs in <code>ZoomIDScanCustomization</code>.</li>
                        <li>New APIs <code>ZoomIDScanCustomization.captureScreenBackgroundColor</code>, <code>ZoomIDScanCustomization.captureFrameStrokeColor</code>, <code>ZoomIDScanCustomization.captureFrameStrokeWidth</code>, and <code>ZoomIDScanCustomization.captureFrameCornerRadius</code>. These are used to configure the look of the ID Scan Capture Frame.</li>
                        <li>New APIs <code>ZoomGuidanceCustomization.retryScreenIdealZoomImage</code> and <code>ZoomGuidanceCustomization.cameraPermissionsScreenImage</code>. These have been added to replace the deprecated APIs in <code>ZoomGuidanceImagesCustomization</code> for configuring the Retry Screen’s Ideal Image and Camera Permissions Screen Image.</li>
                        <li>Deprecated <code>ZoomGuidanceImagesCustomization</code>, <code>ZoomGuidanceCustomization.imageCustomization</code>, <code>ZoomGuidanceImagesCustomization.idealZoomImage</code>, and <code>ZoomGuidanceImagesCustomization.cameraPermissionsScreenImage</code>. The Retry Screen’s Ideal Image and Camera Permissions Screen Image are now configured using the new APIs added to <code>ZoomGuidanceCustomization</code>.</li>
                        <li>Update Sample App look and feel.</li>
                        <li>Misc. bug fixes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-ios-sdk-v8.4.1">FaceTec iOS SDK v8.4.1</h3>
                      <p className="version-date">March 18, 2020</p>
                      <ul>
                        <li>Misc. Fixes to reduce memory consumption.</li>
                        <li>Misc. bug fixes.</li>
                        <li>Time-based Session Images have been deprecated and will be removed in an upcoming version of the FaceTec SDK. Usage of these API consume device resources and does not provide much additional value over standard Audit Images now that the Get Ready Screen is a required component of the FaceTec SDK User Experience.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-ios-sdk-v8.4.0">FaceTec iOS SDK v8.4.0</h3>
                      <p className="version-date">March 13, 2020</p>
                      <ul>
                        <li>Unmanaged Sessions and associated feature flags are removed. This includes undocumented feature flags that previously allowed control over FaceTec Frame size, top margin, setting semi-transparent backgrounds and oval strokes, low light mode disablement, and removal of the Get Ready and Retry Screens.</li>
                        <li><p>New Feature: <Link to="/session-tokens">Session Tokens</Link>.</p></li>
                        <li>Updated the Sample App to use Session Tokens. </li>
                        <li>New API <code>ZoomFeedbackCustomization.relativeWidth</code> for specifying the desired width of the FaceTec SDK Feedback Bar.</li>
                        <li>New APIs <code>ZoomGuidanceCustomization.buttonRelativeWidth</code> and <code>ZoomIDScanCustomization.buttonRelativeWidth</code> for specifying the desired width of the action buttons during Guidance Screens and Identity Check Screens.</li>
                        <li>New API <code>ZoomGuidanceCustomization.enableRetryScreenBulletedInstructions</code> to control whether the Retry Screen instruction messages are separated out and preceded with bullet-points, or instead, combined to form a multi-line sentence(s).</li>
                        <li>New API <code>ZoomCancelButtonCustomization.customLocation</code> for specifying custom frame location and size for the cancel button. <code>ZoomCancelButtonCustomization.location</code> must be set to a new enum value: <code>ZoomCancelButtonLocationCustom</code> in order to use the customLocation API.</li>
                        <li>New API <code>ZoomFrameCustomization.shadow</code> for specifying the shadow displayed behind the FaceTec SDK Frame. <code>ZoomFrameCustomization.shadow</code> can be set to an instance of the new <code>ZoomShadow</code> class object.</li>
                        <li>New API <code>ZoomFeedbackCustomization.shadow</code> for specifying the shadow displayed behind the FaceTec SDK Feedback Bar. <code>ZoomFeedbackCustomization.shadow</code> can be set to an instance of the new <code>ZoomShadow</code> class object.</li>
                        <li>New API class <code>ZoomShadow</code>, offering the ability to specify a shadow's color, opacity, radius, offset, and/or path inset. To be used as a value for <code>ZoomFeedbackCustomization.shadow</code> and/or <code>ZoomFeedbackCustomization.shadow</code>.</li>
                        <li>New APIs <code>ZoomGuidanceCustomization.retryScreenSlideshowImages</code>, <code>ZoomGuidanceCustomization.retryScreenSlideshowInterval</code>, and <code>ZoomGuidanceCustomization.enableRetryScreenSlideshowShuffle</code>. These are used to set an array of ‘ideal’ example images to cycle through on the Retry Screen. Allows for control over the interval between image transitions, and whether to randomly shuffle the order of the image array before each time the retry screen is shown.</li>
                        <li>New APIs <code>ZoomGuidanceCustomization.retryScreenImageBorderColor</code>, <code>ZoomGuidanceCustomization.retryScreenImageBorderWidth</code>, and <code>ZoomGuidanceCustomization.retryScreenImageCornerRadius</code>. These are used to control the image border color, width, and corner radius of the images shown on the Retry Screen. For upgrading developers, please note, the new default values for these customizations are custom and thus differ from the Retry Screen image border styles in previous versions.</li>
                        <li>New API <code>ZoomGuidanceCustomization.retryScreenOvalStrokeColor</code> for controlling the color of the oval stroke that overlays the ‘ideal’ example image on the Retry Screen.</li>
                        <li>New APIs <code>ZoomGuidanceCustomization.buttonTextDisabledColor</code>, <code>ZoomGuidanceCustomization.buttonBackgroundDisabledColor</code>, <code>ZoomIDScanCustomization.buttonTextDisabledColor</code>, and <code>ZoomIDScanCustomization.buttonBackgroundDisabledColor</code>. These are used to control the button text and background color of the action buttons. For upgrading developers, please note, the new default values for these customizations are custom and thus differ from the disabled button styles in previous versions.</li>
                        <li>New APIs <code>ZoomResultScreenCustomization.messageTextSpacing</code>, <code>ZoomGuidanceCustomization.headerTextSpacing</code>, <code>ZoomGuidanceCustomization.subtextTextSpacing</code>, <code>ZoomGuidanceCustomization.buttonTextSpacing</code>, <code>ZoomIDScanCustomization.headerTextSpacing</code>, <code>ZoomIDScanCustomization.subtextTextSpacing</code>, and <code>ZoomIDScanCustomization.buttonTextSpacing</code>. These are used to control the spacing between the characters of the text.</li>
                        <li>New API <code>ZoomOverlayCustomization.showBrandingImage</code> to control whether to show a branding image on the overlay background.</li>
                        <li>ID Scan Capture Screen Frame images have been deprecated and will be removed in an upcoming version of the FaceTec SDK. Future versions will configure the ID Scan Capture Frame's background and stroke colors programmatically.</li>
                        <li>Update the look and feel of the Sample App.</li>
                        <li>ID Scan Capture Screen Frame images have been deprecated and will be removed in an upcoming version of the FaceTec SDK. Future versions will configure the ID Scan Capture Frame's background and stroke colors programmatically.</li>
                        <li>Fixed an issue in Photo ID Match where taking a photo could trigger the camera shutter sound multiple times.</li>
                        <li>Miscellaneous improvements to performance, security, reliability, and UX.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-ios-sdk-v8.3.2">FaceTec iOS SDK v8.3.2</h3>
                      <p className="version-date">March 6, 2020</p>
                      <ul>
                        <li>See 8.4.0 Notes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-ios-sdk-v8.3.1">FaceTec iOS SDK v8.3.1</h3>
                      <p className="version-date">February 19, 2020</p>
                      <ul>
                        <li>Improve reliability of Audit Trail and Low Quality Audit Trail Images.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-ios-sdk-v8.3.0">FaceTec iOS SDK v8.3.0</h3>
                      <p className="version-date">February 14, 2020</p>
                      <ul>
                        <li>New <code>resultAnimationSuccessBackgroundImage</code> and <code>resultAnimationUnsuccessBackgroundImage</code> APIs. These APIs allow customization of the background for the Result Screen animation.</li>
                        <li>New <code>customActivityIndicatorImage</code> and <code>customActivityIndicatorRotationInterval</code> APIs. These APIs allow customization of the activity indicator animation.</li>
                        <li>New <code>showUploadProgressBar</code> API. This API controls the disablement of the progress bar.</li>
                        <li><p>See <Link to="/ui-customization">FaceTec UI Customization Reference</Link> for the latest available customizations.</p></li>
                        <li>Misc. bug fixes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-ios-sdk-v8.2.0">FaceTec iOS SDK v8.2.0</h3>
                      <p className="version-date">January 24, 2020</p>
                      <ul>
                        <li><strong>Unmanaged Sessions</strong> and associated feature flags are now deprecated and support will be removed in 8.3.  This includes undocumented feature flags that previously allowed control over FaceTec Frame size, top margin, setting semi-transparent backgrounds and oval strokes, low light mode disablement, and removal of the Get Ready and Retry Screens.  Unmanaged Sessions are removed in Browser and deprecated in future versions of iOS/Android to ensure the highest user conversion rates possible and ensure the highest level of security by default.</li>
                        <li>Internal updates to support the upcoming release of <strong>FaceTec Server Dashboard</strong>, a web interface that will ship in an upcoming version of FaceTec Server that gives FaceTec Customers and Partners the ability to review and inspect all end user interactions with the FaceTec SDK platform, including Audit Trail Images, Liveness Checks, Enrollments, Authentications, Photo ID Matches, and enables the ability to search for Duplicate Accounts and Manage a Fraudulent User List.</li>
                        <li>New <code>ZoomFaceMapMetrics.lowQualityAuditTrailCompressedBase64</code> API.  This API returns an array of Audit Trail Images that illustrate the likely cause of Liveness or Matching retry. The 0th image of this array is also used on the Retry Screen.</li>
                        <li>New <code>setLowLightCustomization</code> API.  This API takes the same ZoomCustomization object that <code>setCustomization</code> does, but controls what FaceTec looks like in low light mode.</li>
                        <li>Low light environments are now detected on the "Get Ready" Screen, speeding up User Sessions, and increasing usability and user success rates.</li>
                        <li>Fixes for compatibility and better camera size and aspect selection across devices.</li>
                        <li>Fixes for better screen transitions and general look and feel improvements across devices.</li>
                        <li>Improved compatibility and UX for Photo ID Match screens.</li>
                        <li>Numerous of other internal stability, performance, and security improvements.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-ios-sdk-v8.1.0">FaceTec iOS SDK v8.1.0</h3>
                      <p className="version-date">December 18, 2019</p>
                      <ul>
                        <li>The FaceTec 8.1.0 release contains improvements to security, usability, user experience, and developer experience.  FaceTec SDKs v8.1.0 is non-breaking and can be installed by a simple binary replacement.</li>
                        <li>FaceTec Developer Docs Site refresh!</li>
                        <li>Default user experience refresh.</li>
                        <li>Algorithm accuracy improvements.</li>
                        <li>There is now just one main Sample App to demonstrate core functionality.</li>
                        <li>Added a Design Showcase button that toggles between several compelling "themes" that demonstrate how the FaceTec SDK Customization class can be used to significantly alter the look and feel of FaceTec SDKs.</li>
                        <li>ZoomManagedSession has been refactored into much small components called Processors.  This code remains as open source and can be found in the Sample App.</li>
                        <li>The Lockout Screen has been removed.</li>
                        <li>All guidance screens containing "pictograms" have been removed.  This includes the Angle Guidance, Lighting Guidance, and Webcam Guidance (Browser-only) Screens.  The Get Ready Screen (for new sessions) and the Retry Guidance Screens are now the only two required screens.</li>
                        <li>Fixed issues where certain customizations were not getting applied and where certain customization combinations resulted in undesirable visual effects.</li>
                        <li>Numerous additional FaceMap security and integrity checks are performed throughout the FaceTec SDK process.</li>
                        <li>Fallback images have been embedded into the SDK to improve integration experience.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-ios-sdk-v8.0.7">FaceTec iOS SDK v8.0.7</h3>
                      <p className="version-date">November 29, 2019</p>
                      <ul>
                        <li>Add new API <code>ZoomFaceBiometricMetrics.auditTrailCompressedBase64</code>. This API returns the FaceTec SDK Audit Trail Images with optimal compression applied and encoded to base64.  The data from this API should be used with the Audit Trail Verification API in FaceTec Server.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-ios-sdk-v8.0.6">FaceTec iOS SDK v8.0.6</h3>
                      <p className="version-date">November 15, 2019</p>
                      <ul>
                        <li>Removed the Face Angle Instruction Slide from the New User Guidance Screens. The Get Ready To FaceTec Screen is now the initial, and only, New User Guidance Screen.</li>
                        <li>Minor bug fixes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-ios-sdk-v8.0.5">FaceTec iOS SDK v8.0.5</h3>
                      <p className="version-date">November 7, 2019</p>
                      <ul>
                        <li>Minor bug fixes and performance improvements.</li>
                        <li>Updates to API documentation.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-ios-sdk-v8.0.4">FaceTec iOS SDK v8.0.4</h3>
                      <p className="version-date">October 4, 2019</p>
                      <ul>
                        <li>The customizable branding logo that appears on the first New User Guidance Screen is now disabled by default.  This can be enabled by using the <code>ZoomIDScanCustomization.showSelectionScreenBrandingImage</code> API.</li>
                        <li>Fixed issues around scenarios where if interface components were disabled, the image resources would still be required.</li>
                        <li>ID Scan images are now viewable from the Complete App by pressing the images icon after completing an Identity Check.</li>
                        <li>Performance improvements.</li>
                        <li>Misc UX fixes on certain screen sizes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-ios-sdk-v8.0.3">FaceTec iOS SDK v8.0.3</h3>
                      <p className="version-date">September 27, 2019</p>
                      <ul>
                        <li>Added Zoom.strings to release package</li>
                        <li>Updates to Sample Apps for consistency and clarity.</li>
                        <li>Minor bug fixes, stability improvements, and performance.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-ios-sdk-v8.0.2">FaceTec iOS SDK v8.0.2</h3>
                      <p className="version-date">September 26, 2019</p>
                      <ul>
                        <li><p>Updates to support iOS 13 changes.</p></li>
                        <li><p>Fix issue where ZoomManagedSession functions, when pulled from ZoomManagedSessionSource folder into the developer application, were not able to be called.</p></li>
                        <li><p>Fix several stability issues.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-ios-sdk-v8.0.1">FaceTec iOS SDK v8.0.1</h3>
                      <p className="version-date">September 20, 2019</p>
                      <ul>
                        <li><p>Updated sample app code for clarity and consistency.</p></li>
                        <li><p>Updated ZoomManagedSessionSource files for clarity and consistency.</p></li>
                        <li><p>Added blur customizations to guidance and results screens.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h2 id="zoom-ios-8.0.0-has-been-released">FaceTec SDKs v8.0.0 has been released!</h2>
                      <p className="version-date">September 13, 2019</p>
                      <ul>
                        <li><p>Please see the <Link to="/docs">docs home</Link> for updated guides including Quick Start, Advanced, and Customizations.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>
                    </section>

                    <section id="v7.0">
                      <h3 id="zoom-ios-sdk-v7.0.18">FaceTec iOS SDK v7.0.18</h3>
                      <p className="version-date">June 20, 2019</p>
                      <ul>
                        <li><p>Misc. bug fixes.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-ios-sdk-v7.0.17">FaceTec iOS SDK 7.0.17</h3>
                      <p className="version-date">June 16, 2019</p>
                      <ul>
                        <li><p>Minor bug fixes.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-ios-sdk-v7.0.16">FaceTec iOS SDK v7.0.16</h3>
                      <p className="version-date">May 17, 2019</p>
                      <ul>
                        <li><p>Fix certain edge cases where FaceTec would cancel due to low available OS memory.</p></li>
                        <li><p>Minor bug fixes.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-ios-sdk-v7.0.15">FaceTec iOS SDK v7.0.15</h3>
                      <p className="version-date">April 17, 2019</p>
                      <ul>
                        <li><p>Misc. bug fixes.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-ios-sdk-v7.0.14">FaceTec iOS SDK v7.0.14</h3>
                      <p className="version-date">April 1, 2019</p>
                      <ul>
                        <li><p>Initial implementation of FaceTec SDKs Generation 2 (G2) UX -- User Session Capture time is <strong>dramatically reduced</strong> for all users.</p></li>
                        <li><p>Misc. fixes to Sample App code.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-ios-sdk-v7.0.13">FaceTec iOS SDK v7.0.13</h3>
                      <p className="version-date">March 26, 2019</p>
                      <ul>
                        <li><p>Misc. bug fixes.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-ios-sdk-v7.0.11">FaceTec iOS SDK v7.0.11</h3>
                      <p className="version-date">March 12, 2019</p>
                      <h4>Updates & Bug Fixes</h4>
                      <ul>
                        <li><p>Misc. bug fixes.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-ios-sdk-v7.0.9">FaceTec iOS SDK v7.0.9</h3>
                      <p className="version-date">February 21, 2019</p>
                      <ul>
                        <li><p>Updated Sample Apps for code clarity.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-ios-sdk-v7.0.7">FaceTec iOS SDK v7.0.7</h3>
                      <p className="version-date">January 31, 2019</p>
                      <h4>Bug Fixes</h4>
                      <ul>
                        <li><p>Fix issue with ZoomCustomization&rsquo;s class setter methods on some sub-class object instances.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-ios-v7.0.4">v7.0.4</h3>
                      <p className="version-date">January 10, 2019</p>
                      <h4>Bug fixes and Time based session images.</h4>
                      <ul>
                        <ul>
                          <li><p>Added time based session images feature. See documentaion for more information.</p></li>
                          <li><p>Fix for constraint error.</p></li>
                          <li><p>Fix bug when using attempting FaceTec in landscape mode.</p></li>
                        </ul>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-ios-v7.0.0">v7.0.0</h3>
                      <p className="version-date">December 14, 2018</p>
                      <h4>Platform-wide update to FaceTec&rsquo;s industry-leading face authentication technology.<br /><br />Major Updates:<br /><br /></h4>
                      <ul>
                        <ul>
                          <li><p>SDK Minification Work - the iOS and Android libs now add less than 8MB to your client application!</p></li>
                          <li><p>Swift dependency has been completely removed on iOS.  This has resulted in a smaller and faster iOS library.  Because of this, FaceTec SDKs will also not require a recompilation for every update to Xcode, iOS, or Swift, which is a huge win for our clients reducing external dependencies.</p></li>
                          <li><p>FaceTec SDKs now be launched in non-fullscreen mode.  This mode enables developers to prevent a full-screen takeover approach.  The developer application can now continue to appear in the background as FaceTec performs Liveness/Enrollment/Authentication.</p></li>
                          <li><p>Updates to Function names, parameters, and results to have consistent API across iOS, Android, JS, Server.</p></li>
                          <li><p>devices now return devicePartialLivenessScore and devicePartialLivenessResult instead of livenessScore and livenessResult, since the real result now comes from the FaceTec Server SDK output.</p></li>
                          <li><p>Add numerous behavior customizations including lockout screen, retry screen, low light mode behavior, transition in/out customizations.</p></li>
                          <li><p>Better FaceTec Audit Trail Image selection.  Increase number of FaceTec SDKs Audit Trail Images returned to 6.</p></li>
                          <li><p>Full support usage logs to be sent to FaceTec via SFTP.</p></li>
                          <li><p>IOS ONLY - add customization that allows FaceTec background to use built-in iOS blur effects.</p></li>
                          <li><p>Improved UI, handling, and customizability for iPads and iPhone X devices.</p></li>
                          <li><p>Managed Rest API - Ability to save & return thumbnail image attached to facemap</p></li>
                        </ul>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>
                    </section>
                  </div>
                </Tab>
                <Tab eventKey="android" title="Android">
                  <br/>
                  <div id="android-tab">
                    <section id="v8.0">

                    <h3 id="zoom-android-sdk-v8.12.3">FaceTec Android SDK v8.12.3</h3>
                      <p className="version-date">August 18, 2020</p>
                      <ul>
                        <li>Misc. bug fixes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-android-sdk-v8.12.2">FaceTec Android SDK v8.12.2</h3>
                      <p className="version-date">August 10, 2020</p>
                      <ul>
                        <li>Misc. bug fixes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-android-sdk-v8.12.1">FaceTec Android SDK v8.12.1</h3>
                      <p className="version-date">July 10, 2020</p>
                      <ul>
                        <li>Misc. bug fixes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-android-sdk-v8.12.0">FaceTec Android SDK v8.12.0</h3>
                      <p className="version-date">June 26, 2020</p>
                      <ul>
                        <li>8.12.0 adds new APIs for full customization of the progress, success, and retry animations.  Example animations are now included in the Sample App for the Psuedo-Fullscreen, Well-Rounded, and eKYC Themes.</li>
                        <li>Added APIs <code>ZoomResultScreenCustomization.customActivityIndicatorAnimation</code>, <code>ZoomResultScreenCustomization.customResultSuccessAnimation</code> and <code>ZoomResultScreenCustomization.customResultUnsuccessAnimation</code>. These can be used for configuring custom activity indicator and result animations on the Result Screen. </li>
                        <li>Added API <code>ZoomResultScreenCustomization.animationRelativeScale</code>. This can be used to set the relative sizing of the activity indicator and result animations shown on the Result Screen. </li>
                        <li>Misc. bug fixes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-android-sdk-v8.11.0">FaceTec Android SDK v8.11.0</h3>
                      <p className="version-date">June 5, 2020</p>
                      <ul>
                        <li>Added API <code>ZoomCustomization.sessionTimerCustomization</code>and its class <code>ZoomSessionTimerCustomization</code>. This API and class object can be used to configure the timeout lengths for the Liveness Check and ID Scan processes. </li>
                        <li>Added API <code>ZoomSessionTimerCustomization.livenessCheckNoInteractionTimeout</code>. This API can be used to specify the amount of time, in seconds, that a user has to complete a Liveness Check Session. The previous API for setting the Liveness Check timeout length, <code>ZoomSDK.setActiveTimeoutInSeconds()</code>, has been deprecated and will be removed in an upcoming version of our SDK.</li>
                        <li>Added API <code>ZoomSessionTimerCustomization.idScanNoInteractionTimeout</code>. This API can be used to specify the amount of time, in seconds, that a user has to complete a Liveness Check Session. </li>
                        <li>Added API <code>ZoomFaceMapResultCallback.uploadMessageOverride()</code> and <code>ZoomIDScanResultCallback.uploadMessageOverride()</code>. These callbacks can be used to dynamically update the message text displayed on the Result Screen during server-side work.</li>
                        <li>Removed <code>ZoomGuidanceCustomization.imageCustomization</code> API and <code>ZoomGuidanceImagesCustomization</code> class (deprecated in version 8.5).</li>
                        <li>Removed <code>ZoomFaceBiometricMetrics.timeBasedSessionImages</code> API (deprecated in version 8.4.1).</li>
                        <li>Misc. bug fixes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-android-sdk-v8.10.0">FaceTec Android SDK v8.10.0</h3>
                      <p className="version-date">May 22, 2020</p>
                      <ul>
                        <li>Added APIs <code>ZoomGuidanceCustomization.readyScreenHeaderAttributedString</code>, <code>ZoomGuidanceCustomization.readyScreenSubtextAttributedString</code>, <code>ZoomGuidanceCustomization.retrySceeenHeaderAttributedString</code>, and <code>ZoomGuidanceCustomization.retryScreenSubtextAttributedString</code>. These allow for configuring an html-attributed string for the various text sections of the Guidance Screens. For instance, these could be used to configure underline styling for part(s) of a text.</li>
                        <li>Misc. bug fixes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-android-sdk-v8.9.1">FaceTec Android SDK v8.9.1</h3>
                      <p className="version-date">May 18, 2020</p>
                      <ul>
                        <li>Misc. bug fixes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-android-sdk-v8.9.0">FaceTec Android SDK v8.9.0</h3>
                      <p className="version-date">May 17, 2020</p>
                      <ul>
                        <li>Added APIs <code>ZoomGuidanceCustomization.readyScreenHeaderFont</code>, <code>ZoomGuidanceCustomization.readyScreenHeaderTextColor</code>,  <code>ZoomGuidanceCustomization.readyScreenHeaderTextSpacing</code>, and <code>ZoomGuidanceCustomization.readyScreenHeaderTextSize</code>. These allow for configuring the text style of the Ready Screen header message, specifically. </li>
                        <li>Added APIs <code>ZoomGuidanceCustomization.readyScreenSubtextFont</code>, <code>ZoomGuidanceCustomization.readyScreenSubtextTextColor</code>,  <code>ZoomGuidanceCustomization.readyScreenSubtextTextSpacing</code>, and  <code>ZoomGuidanceCustomization.readyScreenSubtextTextSize</code>. These allow for configuring the text style of the Ready Screen subtext message, specifically.  </li>
                        <li>Added APIs <code>ZoomGuidanceCustomization.retryScreenHeaderFont</code>, <code>ZoomGuidanceCustomization.retryScreenHeaderTextColor</code>,  <code>ZoomGuidanceCustomization.retryScreenHeaderTextSpacing</code>, and <code>ZoomGuidanceCustomization.retryScreenHeaderTextSize</code>. These allow for configuring the text style of the Retry Screen header message, specifically. </li>
                        <li>Added APIs <code>ZoomGuidanceCustomization.retryScreenSubtextFont</code>, <code>ZoomGuidanceCustomization.retryScreenSubtextTextColor</code>, <code>ZoomGuidanceCustomization.retryScreenSubtextTextSpacing</code>, and <code>ZoomGuidanceCustomization.retryScreenSubtextTextSize</code>. These allow for configuring the text style of the Retry Screen subtext messages, specifically. </li>
                        <li>Localized xml ZoomString resources for the Guidance Screen can now include HTML attribute tags. For instance, HTML '&lt;u&gt;' tags could be used to configure underline styling for part(s) of a text.</li>
                        <li>Misc. bug fixes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-android-sdk-v8.8.0">FaceTec Android SDK v8.8.0</h3>
                      <p className="version-date">May 8, 2020</p>
                      <ul>
                        <li>New API method <code>ZoomFaceMapResultCallback.succeed(ZoomIDScanNextStep idScanNextStep)</code> added for use during Photo ID Match flows. Passing in different values of the new enum <code>ZoomIDScanNextStep</code> allows for control over whether you want to skip directly to either the ID Card (with Front and Back) capture process, or the Passport capture process, or to skip the ID Scan process altogether.<br/>
                        You may want to skip directly to a specific type of ID Scan if you know that your Users are only using one particular type of ID, or you may want to skip the entire ID Scan process if you have custom server-side logic that would deem certain scenarios as not-needing of an ID Scan.
                        </li>
                        <li>Misc. bug fixes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-android-sdk-v8.7.0">FaceTec Android SDK v8.7.0</h3>
                      <p className="version-date">April 24, 2020</p>
                      <ul>
                        <li>New APIs <code>ZoomIDScanCustomization.captureScreenFocusMessageFont</code>, <code>ZoomIDScanCustomization.captureScreenFocusMessageTextColor</code>, <code>ZoomIDScanCustomization.captureScreenFocusMessageTextSize</code>, and <code>ZoomIDScanCustomization.captureScreenFocusMessageTextSpacing</code>. These are used to configure the style of the newly added tap-to-focus message that is displayed below the Capture Frame on the Identity Document Capture Screen.</li>
                        <li>New localized string, <code>ZoomStrings.zoom_idscan_capture_tap_to_focus_message</code>. This is used to set the text of the newly added tap-to-focus message that is displayed below the Capture Frame on the Identity Document Capture Screen.</li>
                        <li>Removed API <code>ZoomIDScanCustomization.reviewScreenDocumentPreviewCornerRadius</code>. The corner radius configured for the Identity Document Capture Frame using <code>ZoomIDScanCustomization.captureFrameCornerRadius</code> will be used for the captured document preview on the Identity Document Review Screen. </li>
                        <li>The FaceTec Android SDK now requires Android 19 (KitKat 4.4+).  Google no longer supports Android 4.3.</li>
                        <li>Misc. bug fixes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-android-sdk-v8.6.1">FaceTec Android SDK v8.6.1</h3>
                      <p className="version-date">April 17, 2020</p>
                      <ul>
                        <li>Misc. bug fixes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-android-sdk-v8.6.0">FaceTec Android SDK v8.6.0</h3>
                      <p className="version-date">April 3, 2020</p>
                      <ul>
                        <li>Add overloaded method to ZoomIDScanResultCallback, <code>ZoomIDScanResultCallback.retry(ZoomIDScanRetryMode, String)</code>, where the second parameter specifies the string to display on the Result Screen for an unsuccessful ID Scan attempt.</li>
                        <li>Misc. bug fixes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-android-sdk-v8.5.0">FaceTec Android SDK v8.5.0</h3>
                      <p className="version-date">March 28, 2020</p>
                      <ul>
                        <li>Removed ID Scan Capture Frame Images. The ID Scan Capture Frame is now configured using the newly added customization APIs in <code>ZoomIDScanCustomization</code>.</li>
                        <li>New APIs <code>ZoomIDScanCustomization.captureScreenBackgroundColor</code>, <code>ZoomIDScanCustomization.captureFrameStrokeColor</code>, <code>ZoomIDScanCustomization.captureFrameStrokeWidth</code>, and <code>ZoomIDScanCustomization.captureFrameCornerRadius</code>. These are used to configure the look of the ID Scan Capture Frame.</li>
                        <li>New APIs <code>ZoomGuidanceCustomization.retryScreenIdealZoomImage</code> and <code>ZoomGuidanceCustomization.cameraPermissionsScreenImage</code>. These have been added to replace the deprecated APIs in <code>ZoomGuidanceImagesCustomization</code> for configuring the Retry Screen’s Ideal Image and Camera Permissions Screen Image.</li>
                        <li>Deprecated <code>ZoomGuidanceImagesCustomization</code>, <code>ZoomGuidanceCustomization.imageCustomization</code>, <code>ZoomGuidanceImagesCustomization.idealZoomImage</code>, and <code>ZoomGuidanceImagesCustomization.cameraPermissionsScreenImage</code>. The Retry Screen’s Ideal Image and Camera Permissions Screen Image are now configured using the new APIs added to <code>ZoomGuidanceCustomization</code>.</li>
                        <li>Remove previously deprecated getZoomFrameAspectRatio() API.</li>
                        <li>Update Sample App look and feel.</li>
                        <li>Misc. bug fixes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-android-sdk-v8.4.1">FaceTec Android SDK v8.4.1</h3>
                      <p className="version-date">March 18, 2020</p>
                      <ul>
                        <li>Misc. Fixes to reduce memory consumption.</li>
                        <li>Misc. bug fixes.</li>
                        <li>Time-based Session Images have been deprecated and will be removed in an upcoming version of the FaceTec SDK. Usage of these API consume device resources and does not provide much additional value over standard Audit Images now that the Get Ready Screen is a required component of the FaceTec SDK User Experience.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-android-sdk-v8.4.0">FaceTec Android SDK v8.4.0</h3>
                      <p className="version-date">March 13, 2020</p>
                      <ul>
                        <li>Unmanaged Sessions and associated feature flags are removed. This includes undocumented feature flags that previously allowed control over FaceTec Frame size, top margin, setting semi-transparent backgrounds and oval strokes, low light mode disablement, and removal of the Get Ready and Retry Screens.</li>
                        <li><p>New Feature: <Link to="/session-tokens">Session Tokens</Link>.</p></li>
                        <li><p>Updated the Sample app to use a new security feature called session tokens. See the <Link to="/session-tokens">Session Tokens Guide</Link> for more details.</p></li>
                        <li>New API <code>ZoomFeedbackCustomization.relativeWidth</code> for specifying the desired width of the FaceTec SDK Feedback Bar.</li>
                        <li>New APIs <code>ZoomGuidanceCustomization.buttonRelativeWidth</code> and <code>ZoomIDScanCustomization.buttonRelativeWidth</code> for specifying the desired width of the action buttons during Guidance Screens and Identity Check Screens.</li>
                        <li>New API <code>ZoomGuidanceCustomization.enableRetryScreenBulletedInstructions</code> to control whether the Retry Screen instruction messages are separated out and preceded with bullet-points, or instead, combined to form a multi-line sentence(s).</li>
                        <li>New API <code>ZoomFrameCustomization.elevation</code> for specifying the elevation of the FaceTec SDK Frame.</li>
                        <li>New API <code>ZoomFeedbackCustomization.elevation</code> for specifying the elevation of the FaceTec SDK Feedback Bar.</li>
                        <li>New APIs <code>ZoomGuidanceCustomization.retryScreenSlideshowImages</code>, <code>ZoomGuidanceCustomization.retryScreenSlideshowInterval</code>, and <code>ZoomGuidanceCustomization.enableRetryScreenSlideshowShuffle</code>. These are used to set an array of ‘ideal’ example images to cycle through on the Retry Screen. Allows for control over the interval between image transitions, and whether to randomly shuffle the order of the image array before each time the retry screen is shown.</li>
                        <li>New APIs <code>ZoomGuidanceCustomization.retryScreenImageBorderColor</code>, <code>ZoomGuidanceCustomization.retryScreenImageBorderWidth</code>, and <code>ZoomGuidanceCustomization.retryScreenImageCornerRadius</code>. These are used to control the image border color, width, and corner radius of the images shown on the Retry Screen. For upgrading developers, please note, the new default values for these customizations are custom and thus differ from the Retry Screen image border styles in previous versions.</li>
                        <li>New API <code>ZoomGuidanceCustomization.retryScreenOvalStrokeColor</code> for controlling the color of the oval stroke that overlays the ‘ideal’ example image on the Retry Screen.</li>
                        <li>New APIs <code>ZoomGuidanceCustomization.buttonTextDisabledColor</code>, <code>ZoomGuidanceCustomization.buttonBackgroundDisabledColor</code>, <code>ZoomIDScanCustomization.buttonTextDisabledColor</code>, and <code>ZoomIDScanCustomization.buttonBackgroundDisabledColor</code>. These are used to control the button text and background color of the action buttons. For upgrading developers, please note, the new default values for these customizations are custom and thus differ from the disabled button styles in previous versions.</li>
                        <li>New APIs <code>ZoomResultScreenCustomization.messageTextSpacing</code>, <code>ZoomGuidanceCustomization.headerTextSpacing</code>, <code>ZoomGuidanceCustomization.subtextTextSpacing</code>, <code>ZoomGuidanceCustomization.buttonTextSpacing</code>, <code>ZoomIDScanCustomization.headerTextSpacing</code>, <code>ZoomIDScanCustomization.subtextTextSpacing</code>, and <code>ZoomIDScanCustomization.buttonTextSpacing</code>. These are used to control the spacing between the characters of the text.</li>
                        <li>New API <code>ZoomOverlayCustomization.showBrandingImage</code> to control whether to show a branding image on the overlay background.</li>
                        <li>ID Scan Capture Screen Frame images have been deprecated and will be removed in an upcoming version of the FaceTec SDK. Future versions will configure the ID Scan Capture Frame's background and stroke colors programmatically.</li>
                        <li>The getZoomFrameAspectRatio() API is deprecated and will be removed in 8.4.</li>
                        <li>Updated the look and feel of the Sample App.</li>
                        <li>Improve Photo ID Scan camera performance. Capturing and processing Photo IDs are much faster.</li>
                        <li>Miscellaneous improvements to performance, security, reliability, and UX.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-android-sdk-v8.3.4">FaceTec Android SDK v8.3.4</h3>
                      <p className="version-date">March 6, 2020</p>
                      <ul>
                        <li>See 8.4.0 Notes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-android-sdk-v8.3.3">FaceTec Android SDK v8.3.3</h3>
                      <p className="version-date">March 2, 2020</p>
                      <ul>
                        <li>Misc. bug fixes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-android-sdk-v8.3.2">FaceTec Android SDK v8.3.2</h3>
                      <p className="version-date">February 26, 2020</p>
                      <ul>
                        <li>Fix issue where ID Scan result was not returned correctly in an edge case.</li>
                        <li>Misc. bug fixes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-android-sdk-v8.3.1">FaceTec Android SDK v8.3.1</h3>
                      <p className="version-date">February 19, 2020</p>
                      <ul>
                        <li>Improve reliability of Audit Trail and Low Quality Audit Trail Images.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-android-sdk-v8.3.0">FaceTec Android SDK v8.3.0</h3>
                      <p className="version-date">February 14, 2020</p>
                      <ul>
                        <li>New <code>resultAnimationSuccessBackgroundImage</code> and <code>resultAnimationUnsuccessBackgroundImage</code> APIs. These APIs allow customization of the background for the Result Screen animation.</li>
                        <li>New <code>customActivityIndicatorImage</code> and <code>customActivityIndicatorRotationInterval</code> APIs. These APIs allow customization of the activity indicator animation.</li>
                        <li>New <code>showUploadProgressBar</code> API. This API controls the disablement of the progress bar.</li>
                        <li><p>See <Link to="/ui-customization">FaceTec UI Customization Reference</Link> for the latest available customizations.</p></li>
                        <li>Misc. bug fixes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-android-sdk-v8.2.0">FaceTec Android SDK v8.2.0</h3>
                      <p className="version-date">January 24, 2020</p>
                      <ul>
                        <li><strong>Unmanaged Sessions</strong> and associated feature flags are now deprecated and support will be removed in 8.3.  This includes undocumented feature flags that previously allowed control over FaceTec Frame size, top margin, setting semi-transparent backgrounds and oval strokes, low light mode disablement, and removal of the Get Ready and Retry Screens.  Unmanaged Sessions are removed in Browser and deprecated in future versions of iOS/Android to ensure the highest user conversion rates possible and ensure the highest level of security by default.</li>
                        <li>Internal updates to support the upcoming release of <strong>FaceTec Server Dashboard</strong>, a web interface that will ship in an upcoming version of FaceTec Server that gives FaceTec Customers and Partners the ability to review and inspect all end user interactions with the FaceTec SDK platform, including Audit Trail Images, Liveness Checks, Enrollments, Authentications, Photo ID Matches, and enables the ability to search for Duplicate Accounts and Manage a Fraudulent User List.</li>
                        <li>New <code>ZoomFaceMapMetrics.lowQualityAuditTrailCompressedBase64</code> API.  This API returns an array of Audit Trail Images that illustrate the likely cause of Liveness or Matching retry. The 0th image of this array is also used on the Retry Screen.</li>
                        <li>New <code>setLowLightCustomization</code> API.  This API takes the same ZoomCustomization object that <code>setCustomization</code> does, but controls what FaceTec looks like in low light mode.</li>
                        <li>Low light environments are now detected on the "Get Ready" Screen, speeding up User Sessions, and increasing usability and user success rates.</li>
                        <li>Fixes for compatibility and better camera size and aspect selection across devices.</li>
                        <li>Fixes for better screen transitions and general look and feel improvements across devices.</li>
                        <li>Improved compatibility and UX for Photo ID Match screens.</li>
                        <li>Numerous of other internal stability, performance, and security improvements.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-android-sdk-v8.1.1">FaceTec Android SDK v8.1.1</h3>
                      <p className="version-date">December 23, 2019</p>
                      <ul>
                      <li><p>Fixed an image resource that had an incorrect file extension.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-android-sdk-v8.1.0">FaceTec Android SDK v8.1.0</h3>
                      <p className="version-date">December 18, 2019</p>
                      <ul>
                        <li>The FaceTec 8.1.0 release contains improvements to security, usability, user experience, and developer experience.  FaceTec SDKs v8.1.0 is non-breaking and can be installed by a simple binary replacement.</li>
                        <li>FaceTec Developer Docs Site refresh!</li>
                        <li>Default user experience refresh.</li>
                        <li>Algorithm accuracy improvements.</li>
                        <li>There is now just one main Sample App to demonstrate core functionality.</li>
                        <li>Added a Design Showcase button that toggles between several compelling "themes" that demonstrate how the FaceTec SDK Customization class can be used to significantly alter the look and feel of FaceTec SDKs.</li>
                        <li>ZoomManagedSession has been refactored into much small components called Processors.  This code remains as open source and can be found in the Sample App.</li>
                        <li>The Lockout Screen has been removed.</li>
                        <li>All guidance screens containing "pictograms" have been removed.  This includes the Angle Guidance, Lighting Guidance, and Webcam Guidance (Browser-only) Screens.  The Get Ready Screen (for new sessions) and the Retry Guidance Screens are now the only two required screens.</li>
                        <li>Fixed issues where certain customizations were not getting applied and where certain customization combinations resulted in undesirable visual effects.</li>
                        <li>Numerous additional FaceMap security and integrity checks are performed throughout the FaceTec SDK process.</li>
                        <li>Fallback images have been embedded into the SDK to improve integration experience.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-android-sdk-v8.0.17">FaceTec Android SDK v8.0.17</h3>
                      <p className="version-date">December 6, 2019</p>
                      <ul>
                      <li><p>Minor bug fixes.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-android-sdk-v8.0.16">FaceTec Android SDK v8.0.16</h3>
                      <p className="version-date">November 29, 2019</p>
                      <ul>
                      <li>Add new API <code>ZoomFaceBiometricMetrics.getAuditTrailCompressedBase64()</code>. This API returns the FaceTec SDK Audit Trail Images with optimal compression applied and encoded to base64.  The data from this API should be used with the Audit Trail Verification API in FaceTec Server.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-android-sdk-v8.0.15">FaceTec Android SDK v8.0.15</h3>
                      <p className="version-date">November 22, 2019</p>
                      <ul>
                        <li>Minor bug fixes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-android-sdk-v8.0.14">FaceTec Android SDK v8.0.14</h3>
                      <p className="version-date">November 21, 2019</p>
                      <ul>
                        <li>Minor bug fixes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-android-sdk-v8.0.13">FaceTec Android SDK v8.0.13</h3>
                      <p className="version-date">November 18, 2019</p>
                      <ul>
                        <li>Minor bug fixes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-android-sdk-v8.0.12">FaceTec Android SDK v8.0.12</h3>
                      <p className="version-date">November 15, 2019</p>
                      <ul>
                        <li>Removed the Face Angle Instruction Slide from the New User Guidance Screens. The Get Ready To FaceTec Screen is now the initial, and only, New User Guidance Screen.</li>
                        <li>Minor bug fixes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-android-sdk-v8.0.11">FaceTec Android SDK v8.0.11</h3>
                      <p className="version-date">November 11, 2019</p>
                      <ul>
                        <li>Minor bug fixes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-android-sdk-v8.0.10">FaceTec Android SDK v8.0.10</h3>
                      <p className="version-date">November 8, 2019</p>
                      <ul>
                        <li>Minor bug fixes.</li>
                        <li>Updates to API documentation.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-android-sdk-v8.0.9">FaceTec Android SDK v8.0.9</h3>
                      <p className="version-date">November 4, 2019</p>
                      <ul>
                        <li>Minor bug fixes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-android-sdk-v8.0.8">FaceTec Android SDK v8.0.8</h3>
                      <p className="version-date">October 29, 2019</p>
                      <ul>
                        <li>Minor bug fixes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-android-sdk-v8.0.7">FaceTec Android SDK v8.0.7</h3>
                      <p className="version-date">October 25, 2019</p>
                      <ul>
                        <li>Resolved potential conflict in manifest due to application backup rules.</li>
                        <li>Misc. UI fixes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-android-sdk-v8.0.6">FaceTec Android SDK v8.0.6</h3>
                      <p className="version-date">October 16, 2019</p>
                      <ul>
                        <li>The Get Ready To FaceTec Screen&rsquo;s oval fill color is now customizable via the <code>ZoomGuidanceCustomization.readyScreenOvalFillColor</code> API.</li>
                        <li>ANDROID/Misc. UI fixes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-android-sdk-v8.0.5">FaceTec Android SDK v8.0.5</h3>
                      <p className="version-date">October 4, 2019</p>
                      <ul>
                        <li>The customizable branding logo that appears on the first New User Guidance Screen is now disabled by default.  This can be enabled by using the <code>ZoomIDScanCustomization.showSelectionScreenBrandingImage</code> API.</li>
                        <li>Fixed issues around scenarios where if interface components were disabled, the image resources would still be required.</li>
                        <li>ID Scan images are now viewable from the Complete App by pressing the images icon after completing an Identity Check.</li>
                        <li>Performance improvements.</li>
                        <li>Misc UX fixes on certain screen sizes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-android-sdk-v8.0.4">FaceTec Android SDK v8.0.4</h3>
                      <p className="version-date">October 1, 2019</p>
                      <ul>
                        <li>Fixed an issue where FaceTec ID Scan images were not returned properly.</li>
                        <li>Minor UI bug fixes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-android-sdk-v8.0.3">FaceTec Android SDK v8.0.3</h3>
                      <p className="version-date">September 27, 2019</p>
                      <ul>
                        <li>Updated ZoomManagedSession.java to work when copied into developer applications.</li>
                        <li>Updates to Sample Apps for consistency and clarity.</li>
                        <li>Minor bug fixes, stability improvements, and performance.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-android-sdk-v8.0.2">FaceTec Android SDK v8.0.2</h3>
                      <p className="version-date">September 20, 2019</p>
                      <ul>
                        <li><p>Fixed several customizations that were not being applied correctly.</p></li>
                        <li><p>Updated sample app code for clarity and consistency.</p></li>
                        <li><p>Updated ZoomManagedSessionSource files for clarity and consistency.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-android-sdk-v8.0.1">FaceTec Android SDK v8.0.1</h3>
                      <p className="version-date">September 13, 2019</p>
                      <ul>
                        <li><p>Add x86_64 stub native library back to package for compat with certain Play Store deployment types.</p></li>
                        <li><p>Fix several stability issues.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h2 id="zoom-android-8.0.0-has-been-released">FaceTec SDKs v8.0.0 has been released!</h2>
                      <p className="version-date">September 13, 2019</p>
                      <ul>
                        <li><p>Please see the <Link to="/docs">docs home</Link> for updated guides including Quick Start, Advanced, and Customizations.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>
                    </section>

                    <section id="v7.0">
                      <h3 id="zoom-android-sdk-v7.0.14">FaceTec Android SDK v7.0.14</h3>
                      <p className="version-date">July 18, 2019</p>
                      <ul>
                        <li><p>Misc. bug fixes.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-android-sdk-v7.0.13">FaceTec Android SDK 7.0.13</h3>
                      <p className="version-date">June 16, 2019</p>
                      <ul>
                        <li><p>Minor bug fixes.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-android-sdk-v7.0.12">FaceTec Android SDK v7.0.12</h3>
                      <p className="version-date">May 17, 2019</p>
                      <ul>
                        <li><p>FaceTec Audit Trail images and FaceTec 3D FaceMaps are returned much faster when getting them off the FaceTec SDK result object.</p></li>
                        <li><p>Minor bug fixes.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-android-sdk-v7.0.11">FaceTec Android SDK v7.0.11</h3>
                      <p className="version-date">April 17, 2019</p>
                      <ul>
                        <li><p>Compatibility fixes for a few android devices.</p></li>
                        <li><p>Make all {"<"}uses-feature{">"} optional in AndroidManifest.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-android-sdk-v7.0.10">Android SDK v7.0.10</h3>
                      <p className="version-date">April 1, 2019</p>
                      <ul>
                        <li><p>Initial implementation of FaceTec SDKs Generation 2 (G2) UX -- User Session Capture time is <strong>dramatically reduced</strong> for all users.</p></li>
                        <li><p>Misc. fixes to Sample App code.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-android-sdk-v7.0.8">Android SDK v7.0.8</h3>
                      <p className="version-date">February 21, 2019</p>
                      <ul>
                        <li><p>Updated Sample Apps for code clarity.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-android-sdk-v7.0.7">FaceTec Android SDK 7.0.7</h3>
                      <p className="version-date">February 15, 2019</p>
                      <h4>Updates & Bug Fixes</h4>
                      <ul>
                        <ul>
                        <li><p>Added support for customization of Accessibility TalkBack for the FaceTec SDK cancel button. Search for the string name "zoom_accessibility_cancel_button" and insert your customized message for TalkBack to read. More info on string customization can be found <span><Link to="/string-customization-guide">here</Link></span>.</p></li>
                        <li><p>Updated Oval shape on very wide aspect ratios to improve usability.</p></li>
                        <li><p>Misc. UI, performance, and stability bug fixes.</p></li>
                        </ul>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-android-sdk-v7.0.6">Android SDK v7.0.6</h3>
                      <p className="version-date">January 31, 2019</p>
                      <h4>Bug Fixes</h4>
                      <ul>
                        <ul>
                        <li><p>Initialize FaceTec in the Basic App so generated facemaps will work with FaceTec&rsquo;s managed REST APIs.</p></li>
                        </ul>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-android-sdk-v7.0.4">v7.0.4</h3>
                      <p className="version-date">January 10, 2019</p>
                      <h4>Bug fixes and Time based session images.</h4>
                      <ul>
                        <ul>
                          <li><p>Added time based session images feature. See documentaion for more information.</p></li>
                        </ul>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-android-sdk-v7.0.0">v7.0.0</h3>
                      <p className="version-date">December 14, 2018</p>
                      <h4>Platform-wide update to FaceTec&rsquo;s industry-leading face authentication technology.<br /><br />Major Updates:<br /><br /></h4>
                      <ul>
                        <ul>
                          <li><p>SDK Minification Work - the iOS and Android libs now add less than 8MB to your client application!</p></li>
                          <li><p>FaceTec SDKs now be launched in non-fullscreen mode.  This mode enables developers to prevent a full-screen takeover approach.  The developer application can now continue to appear in the background as FaceTec performs Liveness/Enrollment/Authentication.</p></li>
                          <li><p>Updates to Function names, parameters, and results to have consistent API across iOS, Android, JS, Server.</p></li>
                          <li><p>devices now return devicePartialLivenessScore and devicePartialLivenessResult instead of livenessScore and livenessResult, since the real result now comes from the FaceTec Server SDK output.</p></li>
                          <li><p>Add numerous behavior customizations including lockout screen, retry screen, low light mode behavior, transition in/out customizations.</p></li>
                          <li><p>Better FaceTec Audit Trail Image selection.  Increase number of FaceTec SDKs Audit Trail Images returned to 6.</p></li>
                          <li><p>Full support usage logs to be sent to FaceTec via SFTP.</p></li>
                          <li><p>ANDROID ONLY - add various special animation transitions in and out of FaceTec SDKs experience on Android.</p></li>
                          <li><p>Managed Rest API - Ability to save & return thumbnail image attached to facemap</p></li>
                        </ul>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>
                    </section>
                  </div>
                </Tab>
                <Tab eventKey="server" title="Server">
                  <br/>
                  <div id="server-tab">
                    <section id="v8.0">

                    <h3 id="zoom-server-v8.15.3">FaceTec Server v8.15.3</h3>
                    <p className="version-date">September 3, 2020</p>
                    <ul>
                      <li>Updates to support free 2D Liveness & Spoof Checks.</li>
                      <li>Add /spoof-check-2d to Custom Server.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-v8.15.2">FaceTec Server v8.15.2</h3>
                    <p className="version-date">July 23, 2020</p>
                    <ul>
                      <li><p>Update <code>export</code> function to enable writing across filesystems.</p></li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-v8.15.1">FaceTec Server v8.15.1</h3>
                    <p className="version-date">July 21, 2020</p>
                    <ul>
                      <li><p>Algorithm Improvements & FRR Reductions.</p></li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-v8.15.0">FaceTec Server v8.15.0</h3>
                    <p className="version-date">July 17, 2020</p>
                    <ul>
                      <li><p>1:N Search Improvements.</p></li>
                      <li><p>Stability improvements.</p></li>
                      <li><p>Fix bug where Deleting a User in Custom Server would not delete the 2D Audit Image or in-memory Search reference for the enrollmentIdentifier.</p></li>
                      <li><p>Initial release of the <Link to="/2d-spoof-check">2D Spoof Check API</Link>.</p></li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-v8.14.1">FaceTec Server v8.14.1</h3>
                    <p className="version-date">July 16, 2020</p>
                    <ul>
                      <li>Misc. bug fixes.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-v8.14.0">FaceTec Server v8.14.0</h3>
                    <p className="version-date">July 15, 2020</p>
                    <ul>
                      <li><p>Additional significant improvements to 1:N Search Algorithm performance and behavior.</p></li>
                      <li><p>Fix potential stability issues identified by running the SDK through static analyzers and address sanitizer.</p></li>
                      <li><p>Added a <code>close</code> API to Persisted Search Groups in order to support more convenient syncing of <Link to="/1-to-n-search">Search 3D-DBs</Link> from Primaries to Non-Primaries.</p></li>
                      <li><p><strong>Important Note for Persisted Search Groups</strong>:  This update improves core Algorithms and includes significant optimizations for 1:N Search.  While there are no changes to the API in this release, this update does require Persisted Search Groups to be re-created using FaceMaps from your 1:1 Database. Using Persisted Search Groups from previous versions with this release will result in a no-op.  If you are using Persisted Search Groups, in order to update, just re-create your Persisted Search group by using <code>enrollBatched</code> on the FaceMaps from your 1:1 Database.</p></li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-v8.13.0">FaceTec Server v8.13.0</h3>
                    <p className="version-date">July 10, 2020</p>
                    <ul>
                      <li>1:N Search Improvements.</li>
                      <li>Misc. Algorithm Improvements.</li>
                      <li><p>Improved <a target="_blank" href="https://docs.google.com/document/d/1u3GHHKQXNrQyYN89Bi6nGQuyhHPjhWX0ov1y0phLcmg/preview#">documentation for 1:N Search-related functionality</a>.</p></li>
                      <li>Added example of <code>export</code> functionality and added small improvements to REST Sample Code and Custom Server SDK.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-v8.12.0">FaceTec Server v8.12.0</h3>
                    <p className="version-date">June 26, 2020</p>
                    <ul>
                      <li>Misc. bug fixes.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-v8.11.2">FaceTec Server v8.11.2</h3>
                    <p className="version-date">June 24, 2020</p>
                    <ul>
                      <li>Misc. bug fixes.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-v8.11.1">FaceTec Server v8.11.1</h3>
                    <p className="version-date">June 22, 2020</p>
                    <ul>
                      <li>Misc. bug fixes.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-v8.11.0">FaceTec Server v8.11.0</h3>
                    <p className="version-date">June 5, 2020</p>
                    <ul>
                      <li>Liveness Detection Accuracy has been improved, for lower false rejection rates.</li>
                      <li>Improvements to Identity Document Spoof algorithm accuracy.</li>
                      <li>Misc. bug fixes.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-v8.10.1">FaceTec Server v8.10.1</h3>
                    <p className="version-date">May 29, 2020</p>
                    <ul>
                      <li>Misc. bug fixes.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-v8.10.0">FaceTec Server v8.10.0</h3>
                    <p className="version-date">May 22, 2020</p>
                    <ul>
                      <li><b>Breaking Behavior Change: For the small amount of Partners and Customers still using v7.x.x of the SDK, </b> <code>ZoomInitializeConfig.disableZoom7BrowserFaceMaps</code> is now disabled by default. To support FaceTec v7 Browser, this must now be explicitly enabled.</li>
                      <li>Minor speed improvements.</li>
                      <li>Algorithm improvements.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-v8.9.1">FaceTec Server v8.9.1</h3>
                    <p className="version-date">May 19, 2020</p>
                    <ul>
                      <li>Added a new parameter to the <code>ZoomInitializeConfig</code>. The <code>ZoomIdScanRejectBehavior</code> specifies the rejection behavior when performing a Photo ID Match. The default is <code>DONT_REJECT</code> and means that IDs will be accepted even if the <code>ZoomFullIDStatus</code> is <code>FULL_ID_NOT_DETECTED</code>.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-v8.9.0">FaceTec Server v8.9.0</h3>
                    <p className="version-date">May 15, 2020</p>
                    <ul>
                      <li>The <code>verifyAuditTrail</code> API now runs matching. A new value <code>ZoomAuditTrailVerificationSuccessNoMatch</code> was added to the <code>ZoomAuditTrailVerificationStatus</code> enum to signify that the audit trail image did come from the same session as the FaceMap but did not match.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-v8.8.1">FaceTec Server v8.8.1</h3>
                    <p className="version-date">May 12, 2020</p>
                    <ul>
                      <li>Misc. bug fixes.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-v8.8.0">FaceTec Server v8.8.0</h3>
                    <p className="version-date">May 1, 2020</p>
                    <ul>
                      <li>General improvements to algorithm accuracy.</li>
                      <li>Misc. bug fixes.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-v8.7.0">FaceTec Server v8.7.0</h3>
                    <p className="version-date">April 24, 2020</p>
                    <ul>
                      <li>General improvements to algorithm accuracy.</li>
                      <li>Misc. bug fixes.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-v8.6.0">FaceTec Server v8.6.0</h3>
                    <p className="version-date">April 3, 2020</p>
                    <ul>
                      <li>Significant improvement to Liveness Algorithm accuracy leading to reduced false rejection rate.</li>
                      <li>Add ID Scan anti-tampering APIs.  Please see the javadocs for more information.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-v8.5.0">FaceTec Server v8.5.0</h3>
                    <p className="version-date">March 28, 2020</p>
                    <ul>
                      <li>Significant FRR reduction due to the reduction in error rates.</li>
                      <li>Added feature to persist Search Enrollments using an on-disk database for fast saving and loading of entire search database. Please see the <Link to="/server-integration">FaceTec Server Integration Guide</Link> for more details.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-v8.4.0">FaceTec Server v8.4.0</h3>
                    <p className="version-date">March 13, 2020</p>
                    <ul>
                      <li><p>New Feature: <Link to="/session-tokens">Session Tokens</Link>.</p></li>
                      <li>Significant FRR reduction due to the reduction in error rates.</li>
                      <li>Fixed bug where some Usage Logs were not being outputted in Development Mode.</li>
                      </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-v8.3.2">FaceTec Server v8.3.2</h3>
                    <p className="version-date">March 6, 2020</p>
                    <ul>
                      <li>The retryReason property on the ZoomFaceMapMetrics has been deprecated and will be removed in a future release.</li>
                      <li>Significant FRR reduction due to the reduction in error rates.</li>
                      <li>Significant improvement in the time it takes to perform a search.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-v8.3.1">FaceTec Server v8.3.1</h3>
                    <p className="version-date">February 28, 2020</p>
                    <ul>
                      <li>Small change to initialization code to avoid scenarios where initialization could potentially hang on slow/resource-constrained servers.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-v8.3.0">FaceTec Server v8.3.0</h3>
                    <p className="version-date">February 14, 2020</p>
                    <ul>
                      <li>New <code>enrollForSearchBatched</code> API. This API allows quickly enrolling a batch of FaceMaps for search.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-v8.2.0">FaceTec Server v8.2.0</h3>
                    <p className="version-date">January 24, 2020</p>
                    <ul>
                      <li>The FaceTec 8.2.0 release contains improvements to security, usability, user experience, and developer experience.</li>
                      <li><strong>Behavior change</strong>: <code>ZoomInitializeConfig.disableZoom7BrowserFaceMaps</code> is now disabled by default.  To support FaceTec v7 Browser, this must now be explicitly enabled.</li>
                      <li>Search APIs now have overloaded methods that take a <code>groupIdentifier</code> parameter.  This parameter lets the developer specify separate groups of FaceMaps to search against instead of every FaceMap that was enrolled for search. </li>
                      <li>Improved Liveness Check accuracy leading to a reduction in FRR.</li>
                      <li>Improved Liveness Check performance in difficult lighting conditions.</li>
                      <li>Improve FaceTec 3D FaceMap integrity, security, and anti-reverse-engineering checks.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                    <h3 id="zoom-server-v8.1.0">FaceTec Server v8.1.0</h3>
                    <p className="version-date">December 18, 2019</p>
                    <ul>
                      <li>The FaceTec 8.1.0 release contains improvements to security, usability, user experience, and developer experience.  FaceTec SDKs v8.1.0 is non-breaking and can be installed by a simple binary replacement.</li>
                      <li>FaceTec Developer Docs Site refresh!</li>
                      <li>Improved Liveness Check accuracy leading to a reduction in FRR.</li>
                      <li>Improved Liveness Check performance in difficult lighting conditions.</li>
                      <li>Added new FaceTec 3D FaceMap integrity, security, and anti-reverse-engineering checks.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-v8.0.9">FaceTec Server v8.0.9</h3>
                      <p className="version-date">November 12, 2019</p>
                      <ul>
                      <li>Minor bug fixes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-v8.0.8">FaceTec Server v8.0.8</h3>
                      <p className="version-date">November 8, 2019</p>
                      <ul>
                      <li>Minor bug fixes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-v8.0.7">FaceTec Server v8.0.7</h3>
                      <p className="version-date">November 7, 2019</p>
                      <ul>
                      <li>Minor bug fixes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-v8.0.6">FaceTec Server v8.0.6</h3>
                      <p className="version-date">October 31, 2019</p>
                      <ul>
                      <li>Minor bug fixes.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-v8.0.5">FaceTec Server v8.0.5</h3>
                      <p className="version-date">October 25, 2019</p>
                      <ul>
                      <li>Overall 2D image quality is now denoted by <code>ZoomImageQuality</code> and can be retrieved using <code>ZoomFaceMapMetrics.imageQuality</code>.</li>
                      <li>Increased the likelihood that single images are able to successfully create 2D FaceMaps.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-server-v8.0.4">FaceTec Server v8.0.4</h3>
                      <p className="version-date">October 18, 2019</p>
                      <ul>
                      <li>General improvements to algorithm accuracy.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-server-v8.0.3">FaceTec Server v8.0.3</h3>
                      <p className="version-date">October 4, 2019</p>
                      <ul>
                      <li>Misc. performance and stability fixes.</li>
                      <li>Improvements to several algorithm subsystems to reduce errors rates on real humans (FRRs).</li>
                      <li>General improvements to algorithm accuracy.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-server-v8.0.2">FaceTec Server v8.0.2</h3>
                      <p className="version-date">September 27, 2019</p>
                      <ul>
                      <li>SERVER - Added new Age Estimate group for 22 and over.</li>
                      <li>Updates to Sample Apps for consistency and clarity.</li>
                      <li>Minor bug fixes, stability improvements, and performance.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                      <h3 id="zoom-server-v8.0.1">FaceTec Server v8.0.1</h3>
                      <p className="version-date">September 20, 2019</p>
                      <ul>
                      <li>Minor bug fixes and several minor algorithm improvements.</li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h2 id="zoom-server-v8.0.0-has-been-released">FaceTec SDKs v8.0.0 has been released!</h2>
                      <p className="version-date">September 13, 2019</p>
                      <ul>
                        <li><p>Please see the <Link to="/docs">docs home</Link> for updated guides including Quick Start, Advanced, and Customizations.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>
                    </section>

                    <section id="v7.0">
                      <h3 id="zoom-server-sdk-v7.2.6">FaceTec Server SDK v7.2.6</h3>
                      <p className="version-date">July 29, 2019</p>
                      <ul>
                        <li><p>Misc. bug fixes.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-server-sdk-v7.2.5">FaceTec Server SDK v7.2.5</h3>
                      <p className="version-date">July 25, 2019</p>
                      <ul>
                        <li><p>Misc. bug fixes.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-server-sdk-v7.2.4">FaceTec Server SDK v7.2.4</h3>
                      <p className="version-date">July 15, 2019</p>
                      <ul>
                        <li><p>Misc. bug fixes.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-server-sdk-v7.2.3">FaceTec Server SDK v7.2.3</h3>
                      <p className="version-date">July 10, 2019</p>
                      <ul>
                        <li><p>Misc. Fixes to reduce memory consumption.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-server-sdk-v7.2.2">FaceTec Server SDK v7.2.2</h3>
                      <p className="version-date">July 2, 2019</p>
                      <ul>
                        <li><p>Fixes to reduce memory consumption.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-server-sdk-v7.2.1">FaceTec Server SDK v7.2.1</h3>
                      <p className="version-date">July 1, 2019</p>
                      <ul>
                        <li><p>Misc. Bug fixes and algorithm accuracy improvements.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-server-sdk-v7.2.0">FaceTec Server SDK v7.2.0</h3>
                      <p className="version-date">June 16, 2019</p>
                      <ul>
                        <li><p>Considerable reduction of False Rejects in non-ideal lighting conditions for real users across all platforms.</p></li>
                        <li><p>Expanded Face Matching Levels - Now up to 1/4,200,000 FAR at less than 1% FRR.</p></li>
                        <li><p>Boosted Performance for 2D Photo to 3D FaceMap Matching for ID Photos w/ holograms & artifacts.</p></li>
                        <li><p>New performance/throughput reports available for FaceTec Server.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-server-sdk-v7.1.3">FaceTec Server SDK v7.1.3</h3>
                      <p className="version-date">April 17, 2019</p>
                      <ul>
                        <li><p>Additional data added to FaceTec SDK Usage Statistics.</p></li>
                        <li><p>Misc. bug fixes around incorrect data being logged in the FaceTec SDK Usage Statistics.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-server-sdk-v7.1.2">FaceTec Server SDK v7.1.2</h3>
                      <p className="version-date">March 14, 2019</p>
                      <ul>
                        <li><p>Fixed bug where where facemaps could retrun different Liveness results if they had previously been prepared.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-server-sdk-v7.1.1">FaceTec Server SDK v7.1.1</h3>
                      <p className="version-date">March 10, 2019</p>
                      <ul>
                        <li><p>COMPATIBILITY NOTICE: FaceTec Server 7.1.1 is required for FaceTec Browser SDK 7.1.5 and above.</p></li>
                        <li><p>Stability, security, and algorithmic improvements.</p></li>
                        <li><p>ZoomFacemapMetrics now contains a isLowQuality bool that indicates that performing matching with this FaceMap might not be accurate due to degradation in the image quality.</p></li>
                        <li><p>ZoomSearchResult now returns an array of ZoomCompareResult which contains the enrollmentId and the ZoomSearchMatchLevel.  Please see enum in javadocs for description of match levels.</p></li>
                        <li><p>search now has an optional parameter called maxResults which will limit the amount of results  in the array that is returned from a search.</p></li>
                        <li><p>ZoomAuthenticationResult now contains the ZoomSearchMatchLevel between the enrollment and authentication facemap.</p></li>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>



                      <h3 id="zoom-server-sdk-v7.1.0">FaceTec Server SDK v7.1.0</h3>
                      <p className="version-date">February 15, 2019</p>
                      <h4>API</h4>
                      <h4>Updates & Bug Fixes</h4>
                      <ul>
                        <ul>
                        <li><p>Improvements to algorithm performance.</p></li>
                        <li><p>Misc. performance and stability bug fixes.</p></li>
                        </ul>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>



                      <h3 id="zoom-server-sdk-v7.0.4">v7.0.4</h3>
                      <p className="version-date">January 10, 2019</p>
                      <h4>Bug fixes and Time based session images.</h4>
                      <ul>
                        <ul>
                          <li><p>Minor change to usage logs.</p></li>
                        </ul>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                      <h3 id="zoom-server-sdk-v7.0.0">v7.0.0</h3>
                      <p className="version-date">December 14, 2018</p>
                      <h4>Platform-wide update to FaceTec&rsquo;s industry-leading face authentication technology.<br /><br />Major Updates:<br /><br /></h4>
                      <ul>
                        <ul>
                          <li><p>Stability, security, and algorithmic improvements.</p></li>
                          <li><p><code>retrieveFacemapAnalytics</code> API that developers can use to extract data from facemap helpful for support teams to report issues to FaceTec.</p></li>
                          <li><p>Managed Rest API - Ability to save & return thumbnail image attached to facemap</p></li>
                        </ul>
                      </ul>
                      <hr style={{borderTop:"1px solid #c5c5c5"}}/>
                    </section>


                  </div>
                </Tab>
                <Tab eventKey="rest" title="REST Sample Code">
                  <br/>
                  <div id="rest-tab">
                    <section id="v8.0">

                    <h3 id="rest-sample-code-v8.15.3">REST Sample Code v8.15.3</h3>
                    <p className="version-date">September 3, 2020</p>
                    <ul>
                      <li>Updates to support free 2D Liveness & Spoof Checks.</li>
                      <li>Add /spoof-check-2d to Custom Server.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="rest-sample-code-v8.15.2">REST Sample Code v8.15.2</h3>
                    <p className="version-date">July 23, 2020</p>
                    <ul>
                      <li>Update to FaceTec Server SDK 8.15.2. Please see FaceTec Server SDK 8.15.2 release notes for more details.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="rest-sample-code-v8.15.1">REST Sample Code v8.15.1</h3>
                    <p className="version-date">July 21, 2020</p>
                    <ul>
                      <li>Update to FaceTec Server SDK 8.15.1. Please see FaceTec Server SDK 8.15.1 release notes for more details.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="rest-sample-code-v8.15.0">REST Sample Code v8.15.0</h3>
                    <p className="version-date">July 17, 2020</p>
                    <ul>
                      <li>Update to FaceTec Server SDK 8.15.0. Please see FaceTec Server SDK 8.15.0 release notes for more details.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="rest-sample-code-v8.14.1">REST Sample Code v8.14.1</h3>
                    <p className="version-date">July 16, 2020</p>
                    <ul>
                      <li>Update to FaceTec Server SDK 8.14.1. Please see FaceTec Server SDK 8.14.1 release notes for more details.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="rest-sample-code-v8.14.0">REST Sample Code v8.14.0</h3>
                    <p className="version-date">July 15, 2020</p>
                    <ul>
                      <li>Update to FaceTec Server SDK 8.14.0. Please see FaceTec Server SDK 8.14.0 release notes for more details.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="rest-sample-code-v8.13.0">REST Sample Code v8.13.0</h3>
                    <p className="version-date">July 10, 2020</p>
                    <ul>
                    <li>Update to FaceTec Server SDK 8.13.0. Please see FaceTec Server SDK 8.13.0 release notes for more details.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="rest-sample-code-v8.12.0">REST Sample Code v8.12.0</h3>
                    <p className="version-date">June 26, 2020</p>
                    <ul>
                      <li>Update to FaceTec Server SDK 8.12.0. Please see FaceTec Server SDK 8.12.0 release notes for more details.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="rest-sample-code-v8.11.2">REST Sample Code v8.11.2</h3>
                    <p className="version-date">June 24, 2020</p>
                    <ul>
                      <li>Update to FaceTec Server SDK 8.11.2. Please see FaceTec Server SDK 8.11.2 release notes for more details.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="rest-sample-code-v8.11.1">REST Sample Code v8.11.1</h3>
                    <p className="version-date">June 22, 2020</p>
                    <ul>
                      <li>Update to FaceTec Server SDK 8.11.1. Please see FaceTec Server SDK 8.11.1 release notes for more details.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="rest-sample-code-v8.11.0">REST Sample Code v8.11.0</h3>
                    <p className="version-date">June 5, 2020</p>
                    <ul>
                      <li>Update to FaceTec Server SDK 8.11.0. Please see FaceTec Server SDK 8.11.0 release notes for more details.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="rest-sample-code-v8.10.1">REST Sample Code v8.10.1</h3>
                    <p className="version-date">May 29, 2020</p>
                    <ul>
                      <li>Update to FaceTec Server SDK 8.10.1. Please see FaceTec Server SDK 8.10.1 release notes for more details.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="rest-sample-code-v8.10.0">REST Sample Code v8.10.0</h3>
                    <p className="version-date">May 22, 2020</p>
                    <ul>
                      <li>Update to FaceTec Server SDK 8.10.0. Please see FaceTec Server SDK 8.10.0 release notes for more details.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="rest-sample-code-v8.9.1">REST Sample Code v8.9.1</h3>
                    <p className="version-date">May 19, 2020</p>
                    <ul>
                      <li>Update to FaceTec Server SDK 8.9.1. Please see FaceTec Server SDK 8.9.1 release notes for more details.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="rest-sample-code-v8.9.0">REST Sample Code v8.9.0</h3>
                    <p className="version-date">May 15, 2020</p>
                    <ul>
                      <li>The Liveness endpoint now defaults to using <code>ZoomFaceMapPrepareMode.ONLY_3D</code> for the <code>prepareAndUpdateFaceMap</code> API.  This speeds up the Liveness Checks significantly. Developers may use “3D Only” for Enrollment and Authentication for additional speedups as well, as long as no custom 3D to 2D Matching is required.</li>
                      <li>Update to FaceTec Server SDK 8.9.0.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="rest-sample-code-v8.8.1">REST Sample Code v8.8.1</h3>
                    <p className="version-date">May 12, 2020</p>
                    <ul>
                      <li>Update to FaceTec Server SDK 8.8.1.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="rest-sample-code-v8.8.0">REST Sample Code v8.8.0</h3>
                    <p className="version-date">May 1, 2020</p>
                    <ul>
                      <li>Update to FaceTec Server SDK 8.8.0.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="rest-sample-code-v8.7.0">REST Sample Code v8.7.0</h3>
                    <p className="version-date">April 24, 2020</p>
                    <ul>
                      <li>Update to FaceTec Server SDK 8.7.0.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="rest-sample-code-v8.6.0">REST Sample Code v8.6.0</h3>
                    <p className="version-date">April 3, 2020</p>
                    <ul>
                      <li>Update to FaceTec Server SDK 8.6.0.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="rest-sample-code-v8.5.0">REST Sample Code v8.5.0</h3>
                    <p className="version-date">March 28, 2020</p>
                    <ul>
                      <li>Update to FaceTec Server SDK 8.5.0.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="rest-sample-code-v8.4.0">REST Sample Code v8.4.0</h3>
                    <p className="version-date">March 13, 2020</p>
                    <ul>
                      <li>Update to FaceTec Server SDK 8.4.0.</li>
                      <li><p>API Responses now include the Session Token Status. See the <Link to="/session-tokens">Session Tokens Guide</Link> for more details about the Session Tokens.</p></li>
                      <li>API Responses now include the Audit Trail Verification Status.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="rest-sample-code-v8.3.2">REST Sample Code v8.3.2</h3>
                    <p className="version-date">March 6, 2020</p>
                    <ul>
                      <li>Update to FaceTec Server SDK 8.3.2.</li>
                      <li>Fix a bug where calling /match3d-2d would return a 400 and a message relating to FaceMap decryption when instead the 2D Image sent simply was not high enough quality to process or could not find a face.  The updated response, in this case, will be a 200 and more detailed message.  Please see the REST Sample Code for more details.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                    <h3 id="rest-sample-code-v8.3.0">REST Sample Code v8.3.0</h3>
                    <p className="version-date">February 14, 2020</p>
                    <ul>
                      <li>Update to FaceTec Server SDK 8.3.0.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="rest-sample-code-v8.2.0">REST Sample Code v8.2.0</h3>
                    <p className="version-date">January 24, 2020</p>
                    <ul>
                      <li>Update to FaceTec Server SDK 8.2.0.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="rest-sample-code-v8.1.0">REST Sample Code v8.1.0</h3>
                    <p className="version-date">December 18, 2019</p>
                    <ul>
                      <li>Update to FaceTec Server SDK 8.1.0.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="rest-sample-code-v8.0.13">REST Sample Code v8.0.13</h3>
                    <p className="version-date">December 6, 2019</p>
                    <ul>
                    <li>Implemented reading SFTP Key from file.</li>
                    <li>Implemented reading Private Key for FaceMap Encryption from file.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="rest-sample-code-v8.0.12">REST Sample Code v8.0.12</h3>
                    <p className="version-date">November 21, 2019</p>
                    <ul>
                    <li>Minor bug fixes.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="rest-sample-code-v8.0.11">REST Sample Code v8.0.11</h3>
                    <p className="version-date">November 15, 2019</p>
                    <ul>
                    <li>Minor bug fixes.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="rest-sample-code-v8.0.10">REST Sample Code v8.0.10</h3>
                    <p className="version-date">November 12, 2019</p>
                    <ul>
                    <li>Minor bug fixes.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="rest-sample-code-v8.0.9">REST Sample Code v8.0.9</h3>
                    <p className="version-date">November 11, 2019</p>
                    <ul>
                    <li>Minor bug fixes.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="rest-sample-code-v8.0.8">REST Sample Code v8.0.8</h3>
                    <p className="version-date">November 8, 2019</p>
                    <ul>
                    <li>Minor bug fixes.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="rest-sample-code-v8.0.7">REST Sample Code v8.0.7</h3>
                    <p className="version-date">November 7, 2019</p>
                    <ul>
                    <li>Minor bug fixes.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="rest-sample-code-v8.0.6">REST Sample Code v8.0.6</h3>
                    <p className="version-date">October 31, 2019</p>
                    <ul>
                    <li>Minor bug fixes.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="rest-sample-code-v8.0.5">REST Sample Code v8.0.5</h3>
                    <p className="version-date">October 25, 2019</p>
                    <ul>
                    <li>Overall 2D image quality is now denoted by <code>ZoomImageQuality</code> and can be retrieved using <code>ZoomFaceMapMetrics.imageQuality</code>.</li>
                    <li>Increased the likelihood that single images are able to successfully create 2D FaceMaps.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="rest-sample-code-v8.0.4">REST Sample Code v8.0.4</h3>
                    <p className="version-date">October 18, 2019</p>
                    <ul>
                    <li>General improvements to algorithm accuracy.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="rest-sample-code-v8.0.3">REST Sample Code v8.0.3</h3>
                    <p className="version-date">October 4, 2019</p>
                    <ul>
                    <li>Misc. performance and stability fixes.</li>
                    <li>Improvements to several algorithm subsystems to reduce errors rates on real humans (FRRs).</li>
                    <li>General improvements to algorithm accuracy.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="rest-sample-code-v8.0.2">REST Sample Code v8.0.2</h3>
                    <p className="version-date">September 27, 2019</p>
                    <ul>
                    <li>SERVER - Added new Age Estimate group for 22 and over.</li>
                    <li>Updates to Sample Apps for consistency and clarity.</li>
                    <li>Minor bug fixes, stability improvements, and performance.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="rest-sample-code-v8.0.1">REST Sample Code v8.0.1</h3>
                    <p className="version-date">September 20, 2019</p>
                    <ul>
                    <li>Minor bug fixes and several minor algorithm improvements.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>


                    <h2 id="zoom-rest-8.0.0-has-been-released">FaceTec SDKs v8.0.0 has been released!</h2>
                    <p className="version-date">September 13, 2019</p>
                    <ul>
                      <li><p>Please see the <Link to="/docs">docs home</Link> for updated guides including Quick Start, Advanced, and Customizations.</p></li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>
                    </section>
                  </div>
                </Tab>
                <Tab eventKey="server-docker" title="Custom Server">
                  <br/>
                  <div id="server-docker-tab">
                    <section id="v8.0">

                    <h3 id="zoom-server-docker-v8.15.3">Custom Server SDK v8.15.3</h3>
                    <p className="version-date">September 3, 2020</p>
                    <ul>
                      <li>Updates to support free 2D Liveness & Spoof Checks.</li>
                      <li>Add /spoof-check-2d to Custom Server.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-docker-v8.15.2">Custom Server SDK v8.15.2</h3>
                    <p className="version-date">July 23, 2020</p>
                    <ul>
                      <li>Update to FaceTec Server SDK and FaceTec Server REST Sample Code 8.15.2.  Please see FaceTec Server SDK 8.15.2 release notes for more details.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-docker-v8.15.1">Custom Server SDK v8.15.1</h3>
                    <p className="version-date">July 21, 2020</p>
                    <ul>
                      <li>Update to FaceTec Server SDK and FaceTec Server REST Sample Code 8.15.1.  Please see FaceTec Server SDK 8.15.1 release notes for more details.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-docker-v8.15.0">Custom Server SDK v8.15.0</h3>
                    <p className="version-date">July 17, 2020</p>
                    <ul>
                      <li>Update to FaceTec Server SDK and FaceTec Server REST Sample Code 8.15.0.  Please see FaceTec Server SDK 8.15.0 release notes for more details.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-docker-v8.14.1">Custom Server SDK v8.14.1</h3>
                    <p className="version-date">July 16, 2020</p>
                    <ul>
                      <li>Update to FaceTec Server SDK and FaceTec Server REST Sample Code 8.14.1.  Please see FaceTec Server SDK 8.14.1 release notes for more details.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-docker-v8.14.0">Custom Server SDK v8.14.0</h3>
                    <p className="version-date">July 15, 2020</p>
                    <ul>
                      <li>Update to FaceTec Server SDK and FaceTec Server REST Sample Code 8.14.0.  Please see FaceTec Server SDK 8.14.0 release notes for more details.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-docker-v8.13.0">Custom Server SDK v8.13.0</h3>
                    <p className="version-date">July 10, 2020</p>
                    <ul>
                    <li>Update to FaceTec Server SDK and FaceTec Server REST Sample Code 8.13.0.  Please see FaceTec Server SDK 8.13.0 release notes for more details.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-docker-v8.12.0">Custom Server SDK v8.13.0</h3>
                    <p className="version-date">June 26, 2020</p>
                    <ul>
                      <li>Update to FaceTec Server SDK and FaceTec Server REST Sample Code 8.12.0.  Please see FaceTec Server SDK 8.12.0 release notes for more details.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-docker-v8.11.2">Custom Server SDK v8.11.2</h3>
                    <p className="version-date">June 24, 2020</p>
                    <ul>
                      <li>Update to FaceTec Server SDK and FaceTec Server REST Sample Code 8.11.2.  Please see FaceTec Server SDK 8.11.2 release notes for more details.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-docker-v8.11.1">Custom Server SDK v8.11.1</h3>
                    <p className="version-date">June 22, 2020</p>
                    <ul>
                      <li>Update to FaceTec Server SDK and FaceTec Server REST Sample Code 8.11.1.  Please see FaceTec Server SDK 8.11.1 release notes for more details.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-docker-v8.11.0">Custom Server SDK v8.11.0</h3>
                    <p className="version-date">June 5, 2020</p>
                    <ul>
                      <li>Update to FaceTec Server SDK and FaceTec Server REST Sample Code 8.11.0.  Please see FaceTec Server SDK 8.11.0 release notes for more details.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-docker-v8.10.1">Custom Server SDK v8.10.1</h3>
                    <p className="version-date">May 29, 2020</p>
                    <ul>
                      <li>Update to FaceTec Server SDK and FaceTec Server REST Sample Code 8.10.1.  Please see FaceTec Server SDK 8.10.1 release notes for more details.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-docker-v8.10.0">Custom Server SDK v8.10.0</h3>
                    <p className="version-date">May 22, 2020</p>
                    <ul>
                      <li>Update to FaceTec Server SDK and FaceTec Server REST Sample Code 8.10.0.  Please see FaceTec Server SDK 8.10.0 release notes for more details.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-docker-v8.9.1">Custom Server SDK v8.9.1</h3>
                    <p className="version-date">May 19, 2020</p>
                    <ul>
                      <li>Update to FaceTec Server SDK and FaceTec Server REST Sample Code 8.9.1.  Please see FaceTec Server SDK 8.9.1 release notes for more details.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-docker-v8.9.0">Custom Server SDK v8.9.0</h3>
                    <p className="version-date">May 15, 2020</p>
                    <ul>
                      <li>Update to FaceTec Server SDK and FaceTec Server REST Sample Code 8.9.0.  Please see FaceTec Server SDK 8.9.0 release notes for more details.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-docker-v8.8.1">Custom Server SDK v8.8.1</h3>
                    <p className="version-date">May 12, 2020</p>
                    <ul>
                      <li>Update to FaceTec Server SDK and FaceTec Server REST Sample Code 8.8.1.  Please see FaceTec Server SDK 8.8.1 release notes for more details.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-docker-v8.8.0">Custom Server SDK v8.8.0</h3>
                    <p className="version-date">May 1, 2020</p>
                    <ul>
                      <li>Update to FaceTec Server SDK and FaceTec Server REST Sample Code 8.8.0.  Please see FaceTec Server SDK 8.8.0 release notes for more details.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-docker-v8.7.0">Custom Server SDK v8.7.0</h3>
                    <p className="version-date">April 24, 2020</p>
                    <ul>
                      <li>Update to FaceTec Server SDK and FaceTec Server REST Sample Code 8.7.0.  Please see FaceTec Server SDK 8.7.0 release notes for more details.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-docker-v8.6.0">Custom Server SDK v8.6.0</h3>
                    <p className="version-date">April 3, 2020</p>
                    <ul>
                      <li>Update to FaceTec Server SDK and FaceTec Server REST Sample Code 8.6.0.  Please see FaceTec Server SDK 8.6.0 release notes for more details.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-docker-v8.5.0">Custom Server SDK v8.5.0</h3>
                    <p className="version-date">March 28, 2020</p>
                    <ul>
                      <li>Update to FaceTec Server SDK and FaceTec Server REST Sample Code 8.5.0.  Please see FaceTec Server SDK 8.5.0 release notes for more details.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-docker-v8.4.0">Custom Server SDK v8.4.0</h3>
                    <p className="version-date">March 13, 2020</p>
                    <ul>
                      <li>Update to FaceTec Server SDK and FaceTec Server REST Sample Code 8.4.0.  Please see FaceTec Server SDK 8.4.0 release notes for more details.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>
                    <h3 id="zoom-server-docker-v8.3.2">Custom Server SDK v8.3.2</h3>
                    <p className="version-date">March 6, 2020</p>
                    <ul>
                      <li>Update to FaceTec Server SDK and FaceTec Server REST Sample Code 8.3.2.  Please see FaceTec Server SDK 8.3.2 release notes for more details.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>
                    <h3 id="zoom-server-docker-v8.3.0">Custom Server SDK v8.3.0</h3>
                    <p className="version-date">February 14, 2020</p>
                    <ul>
                      <li>Update to FaceTec Server SDK and FaceTec Server REST Sample Code 8.3.0.  Please see FaceTec Server SDK 8.3.0 release notes for more details.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>
                    <h3 id="zoom-server-docker-v8.2.0">Custom Server SDK v8.2.0</h3>
                    <p className="version-date">January 24, 2020</p>
                    <ul>
                      <li>Update to FaceTec Server SDK and FaceTec Server REST Sample Code 8.2.0.  Please see FaceTec Server SDK 8.2.0 release notes for more details.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-docker-v8.1.0">Custom Server SDK v8.1.0</h3>
                    <p className="version-date">December 18, 2019</p>
                    <ul>
                      <li>Update to FaceTec Server SDK and FaceTec Server REST Sample Code 8.1.0.  Please see FaceTec Server SDK 8.1.0 release notes for more details.</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-docker-v8.0.1">Custom Server SDK v8.0.1</h3>
                    <p className="version-date">November 21, 2019</p>
                    <ul>
                      <li>Updated to FaceTec RestSDK 8.0.12</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    <h3 id="zoom-server-docker-v8.0.0">Custom Server SDK v8.0.0</h3>
                    <p className="version-date">November 12, 2019</p>
                    <ul>
                      <li>Initial release of the Dockerized version of FaceTec Server!</li>
                    </ul>
                    <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                    </section>
                  </div>
                </Tab>
                <Tab eventKey="dashboard" title="Standard Server & Dashboard">
                  <br/>
                  <div id="dashboard-tab">
                  <section id="v8.0">

                  <h3 id="dashboard-v8.15.2">FaceTec Standard Server & Dashboard v8.15.2</h3>
                  <p className="version-date">September 3, 2020</p>
                  <ul>
                    <li>Updates Server Core lib to 8.15.3.</li>
                    <li>Updates to support 2D Liveness & Spoof checks in v9 (within a month).</li>
                  </ul>
                  <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                  <h3 id="dashboard-v8.15.2">FaceTec Standard Server & Dashboard v8.15.2</h3>
                  <p className="version-date">July 23, 2020</p>
                  <ul>
                  <li>Update to FaceTec Server SDK and FaceTec Server REST Sample Code 8.15.2.  Please see FaceTec Server SDK 8.15.2 release notes for more details.</li>
                  </ul>
                  <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                  <h3 id="dashboard-v8.15.1">FaceTec Standard Server & Dashboard v8.15.1</h3>
                  <p className="version-date">July 21, 2020</p>
                  <ul>
                  <li>Update to FaceTec Server SDK and FaceTec Server REST Sample Code 8.15.1.  Please see FaceTec Server SDK 8.15.1 release notes for more details.</li>
                  </ul>
                  <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                  <h3 id="dashboard-v8.15.0">FaceTec Standard Server & Dashboard v8.15.0</h3>
                  <p className="version-date">July 17, 2020</p>
                  <ul>
                  <li>Update to FaceTec Server SDK and FaceTec Server REST Sample Code 8.15.0.  Please see FaceTec Server SDK 8.15.0 release notes for more details.</li>
                  </ul>
                  <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                  <h3 id="dashboard-v8.14.1">FaceTec Standard Server & Dashboard v8.14.1</h3>
                  <p className="version-date">July 16, 2020</p>
                  <ul>
                  <li>Update to FaceTec Server SDK and FaceTec Server REST Sample Code 8.14.1.  Please see FaceTec Server SDK 8.14.1 release notes for more details.</li>
                  </ul>
                  <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                  <h3 id="dashboard-v8.14.0">FaceTec Standard Server & Dashboard v8.14.0</h3>
                  <p className="version-date">July 15, 2020</p>
                  <ul>
                  <li>Update to FaceTec Server SDK and FaceTec Server REST Sample Code 8.14.0.  Please see FaceTec Server SDK 8.14.0 release notes for more details.</li>
                  </ul>
                  <hr style={{borderTop:"1px solid #c5c5c5"}}/>

                  <h3 id="dashboard-v8.13.0">FaceTec Standard Server & Dashboard v8.13.0</h3>
                  <p className="version-date">July 10, 2020</p>
                  <ul>
                    <li>Update to FaceTec Server SDK and FaceTec Server REST Sample Code 8.13.0.  Please see FaceTec Server SDK 8.13.0 release notes for more details.</li>
                  </ul>
                  <hr style={{borderTop:"1px solid #C5C5C5"}}/>

                  <h3 id="dashboard-v8.12.0">FaceTec Standard Server & Dashboard v8.12.0</h3>
                  <p className="version-date">June 26, 2020</p>
                  <ul>
                    <li>Update to FaceTec Server SDK and FaceTec Server REST Sample Code 8.12.0.  Please see FaceTec Server SDK 8.12.0 release notes for more details.</li>
                  </ul>
                  <hr style={{borderTop:"1px solid #C5C5C5"}}/>

                  <h3 id="dashboard-v8.11.2">FaceTec Standard Server & Dashboard v8.11.2</h3>
                  <p className="version-date">June 24, 2020</p>
                  <ul>
                    <li>Update to FaceTec Server SDK and FaceTec Server REST Sample Code 8.11.2.  Please see FaceTec Server SDK 8.11.2 release notes for more details.</li>
                  </ul>
                  <hr style={{borderTop:"1px solid #C5C5C5"}}/>

                  <h3 id="dashboard-v8.11.1">FaceTec Standard Server & Dashboard v8.11.1</h3>
                  <p className="version-date">June 22, 2020</p>
                  <ul>
                    <li>Update to FaceTec Server SDK and FaceTec Server REST Sample Code 8.11.1.  Please see FaceTec Server SDK 8.11.1 release notes for more details.</li>
                  </ul>
                  <hr style={{borderTop:"1px solid #C5C5C5"}}/>

                  <h3 id="dashboard-v8.11.0">FaceTec Standard Server & Dashboard v8.11.0</h3>
                  <p className="version-date">June 5, 2020</p>
                  <ul>
                    <li>Update to FaceTec Server SDK and FaceTec Server REST Sample Code 8.11.0.  Please see FaceTec Server SDK 8.11.0 release notes for more details.</li>
                  </ul>
                  <hr style={{borderTop:"1px solid #C5C5C5"}}/>

                  <h3 id="dashboard-v8.10.1">FaceTec Standard Server v8.10.1</h3>
                  <p className="version-date">May 29, 2020</p>
                  <ul>
                    <li>Update to FaceTec Server SDK and FaceTec Server REST Sample Code 8.10.1.  Please see FaceTec Server SDK 8.10.1 release notes for more details.</li>
                  </ul>
                  <hr style={{borderTop:"1px solid #C5C5C5"}}/>

                  <h3 id="dashboard-v8.10.0">FaceTec Standard Server v8.10.0 & Dashboard v8.10.0</h3>
                  <p className="version-date">May 22, 2020</p>
                  <ul>
                    <li>Update to FaceTec Server SDK and FaceTec Server REST Sample Code 8.10.0.  Please see FaceTec Server SDK 8.10.0 release notes for more details.</li>
                  </ul>
                  <hr style={{borderTop:"1px solid #C5C5C5"}}/>

                  <h3 id="dashboard-v8.9.1">FaceTec Standard Server v8.9.1</h3>
                  <p className="version-date">May 19, 2020</p>
                  <ul>
                    <li>Update to FaceTec Server SDK and FaceTec Server REST Sample Code 8.9.1.  Please see FaceTec Server SDK 8.9.1 release notes for more details.</li>
                  </ul>
                  <hr style={{borderTop:"1px solid #C5C5C5"}}/>

                  <h3 id="dashboard-v8.9.0">FaceTec Standard Server & Dashboard v8.9.0</h3>
                  <p className="version-date">May 15, 2020</p>
                  <ul>
                    <li>Update to FaceTec Server SDK and FaceTec Server REST Sample Code 8.9.0.  Please see FaceTec Server SDK 8.9.0 release notes for more details.</li>
                  </ul>
                  <hr style={{borderTop:"1px solid #C5C5C5"}}/>

                  <h3 id="dashboard-v8.8.0">FaceTec Standard Server & Dashboard v8.8.0</h3>
                  <p className="version-date">May 1, 2020</p>
                  <ul>
                    <li>Added support for 3D to 2D Matching.</li>
                    <li>Developers can now pass a “Custom ID” when calling FSS. This ID will be added to records, logged from FSS, and will be displayed on the Dashboard.</li>
                    <li><code>enrollmentIdentifier</code> is now returned on endpoints that use an <code>enrollmentIdentifier</code>.</li>
                    <li>Added robust configuration options via YAML config file.</li>
                    <li>Significantly improved logging and error handling.</li>
                    <li>Better performance loading Dashboard pages.</li>
                    <li>Multiple optimizations for large data.</li>
                    <li>Updated database schema and properties, renamed collections, and removed excess collections.</li>
                  </ul>
                  <hr style={{borderTop:"1px solid #C5C5C5"}}/>

                  <h3 id="dashboard-v8.6.0">FaceTec Standard Server & Dashboard v8.6.0</h3>
                  <p className="version-date">April 3, 2020</p>
                  <ul>
                    <li>Initial release.</li>
                  </ul>
                  <hr style={{borderTop:"1px solid #C5C5C5"}}/>
                  </section>
                  </div>
                </Tab>
              </Tabs>

            </div>
            <SDKSidebar menuType="main" title="Release Notes"/>
          </div>
        </div>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/js/components/screens/release-notes.jsx